import {  Component, OnInit, ViewChild } from "@angular/core";
import { ErrorStateMatcher } from "@angular/material/core";
import { GeneralService } from "../services/general.service";
import Swal from "sweetalert2";
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Table } from 'primeng/table';
import { PrimeNGConfig } from 'primeng/api';
import * as XLSX from 'xlsx';
import * as jspdf from 'jspdf';
import autoTable from 'jspdf-autotable';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
} from "@angular/forms";
import {LoaderServiceService} from "../../app/services/loaderService.service";
import { DatePipe } from "@angular/common";

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}


@Component({
  selector: "app-analysis",
  templateUrl: "./analysis.component.html",
  styleUrls: ["./analysis.component.css"],
})
export class AnalysisComponent implements OnInit {
  @ViewChild('dt') table: Table;
  @ViewChild('dp') department: Table;
  @ViewChild('dtask') task: Table;
  @ViewChild('dstandard') standard: Table;

  SearchType = [{
    id: 1,
    name: 'Audit Total Score'
  },
  {
    id: 2,
    name: 'Audit Detailed Score'
  },
  {
    id: 3,
    name: 'Department KPI'
  },
  {
    id: 4,
    name: 'Task Compilation'
  },
  {
    id: 5,
    name: 'Standard Compilation'
  },
  {
    id: 6,
    name: 'Common Mistakes'
  }
  ]
  exportColumns!: any[];

  selectedCustomers: any[];




  name = "Angular";
  searchForm: FormGroup;
  compareForm: FormGroup;

  colorarray = [
    'rgba(255, 197, 0, 0.79)',
    'rgba(0, 17, 206, 0.79)',
    'rgba(0, 144, 151, 0.79)',
    'rgba(234,50,186,0.79)',
    'rgba(151,106,84,0.94)',
    'rgba(68,179,96,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,223,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)'];
  view: any[];
  titlefileFormControl = new FormControl("", [Validators.required]);
  fileFormControl = new FormControl("", [Validators.required]);
  processedData: any[] = [];
  form = {
    startdate: "",
    enddate: "",
    moudelid: "",
    category: "",
    branches: []
  };
  GroupBy = [{
    id: 1,
    name: "Yearly",
    value: 'Yearly'
  }, {
    id: 2,
    name: "Monthly",
    value: "Monthly"
  }]
  matcher = new MyErrorStateMatcher();
  displayedColumns: string[] = ["titlefile", "file", "action"];
  audit: any[] = [];
  currentuser: any;
  client: any;
  clientmodule: any[] = [];
  clientaudit: any[] = [];
  canview: boolean;
  modulecat: any[] = [];
  clientauditcat: any[] = [];
  id: any;
  viewData: boolean = false;
  Branches: any;
  AnalysisAuditTotalScoreMonthly: any[] = [];
  MonthsAndYearsBetweenDates: any[] = [];
  FilterdMonthes: any[] = [];
  AnalysisAuditTotalScoreMonthlyDataSets: any[] = [];
  AnalysisAuditTotalScoreDS: any[] = [];
  branchesLabel: any[] = [];
  originalScores: any[] = [];
  chartAnalysisAuditTotalScore: Chart;
  chartAuditDetailedScore: Chart;
  filteredData: any;
  YearsBetweenDates: any[];
  AnalysisAuditTotalScoreYearly: any[] = [];
  chartDepartmentKpiScore: Chart;
  chartTaskCompilationScore: Chart;
  chartStandardCompilationScore: Chart;
  selectedCategories: any;
  departmentsKpiAnalysisObject: any[] = [];

  groupBy: string = 'Monthly'
  branchmulti: Boolean = false;

  loading: boolean = true;
  errorMessage: null;
  successMessage: any;

  email: string;
  subject: string;
  message: string;
  selectedFile: File;
  categoryactive: boolean = false;
  SelectedSearchType: number;
  lastfiltereddataDetailedScore: any[];
  departments: any;
  transformedData: any[] = [];
  departmentIds: any[] = [];
  departmentNames: { id: any; name: string; }[];
  CommonMistakes: any;  
  selectedMonthsDates: Date[] = [];
  selectedYearsDates: Date[] = [];

  availableDatesMonthes: Date[] = [];
  availableDatesYears: Date[] = [];
  datatableaudittotalscore: any[] = [];
  allColumns: any[] = []
  filter: any[] = [];
  tableColumns: any[];
  // test area 
  sales: any[];
  lastYearTotal: number;
  thisYearTotal: number;
  dataKpis: any;
  departmentColumns: any[];
  kpiColumns: any[];
  filterkpis: any[];
  monthsTaskCompilationcolumns: any[];
  monthsTaskCompilationopen_closecolumns: any[];
  taskCompilationCompare: any[];
  filtertasks: any[];
  monthsStandardCompilationcolumns: any[];
  monthsStandardCompilationopen_closecolumns: any[];
  StandardCompilationCompare: any[];
  filterStandard: any[];
  filteredSearchType: { id: number; name: string; }[];
dataview:boolean = false; 
datacompare:boolean = false; 





  constructor(
    public GeneralService: GeneralService,
    private formBuilder: FormBuilder,
    private primengConfig: PrimeNGConfig,
    private LoaderServiceService:LoaderServiceService,
    private datePipe:DatePipe

  ) {
// Get client data and creation date
var clientdata = JSON.parse(localStorage.getItem('ClientData'));
var createdate = this.datePipe.transform(clientdata.createdDate, 'yyyy-MM-dd')!;

// Get start and end dates
const rawStartDate = new Date(createdate);
// Set to first day of the creation month
const startDate = new Date(rawStartDate.getFullYear(), rawStartDate.getMonth(), 1);
const endDate = new Date(); // Current date

// Initialize arrays
this.availableDatesMonthes = [];
this.availableDatesYears = [];

// Add years
for (let year = startDate.getFullYear(); year <= endDate.getFullYear(); year++) {
  this.availableDatesYears.push(new Date(year, 0, 1));
}

// Add months
let current = new Date(startDate);
while (current <= endDate) {
  this.availableDatesMonthes.push(new Date(current));
  current.setMonth(current.getMonth() + 1);
}
console.log('Available Years:', this.availableDatesYears);
console.log('Available Months:', this.availableDatesMonthes);

    //  var createdate= this.datePipe.transform(clientdata.createdDate, 'yyyy-MM-dd')!;
    //  console.log(createdate);


    // // Initialize availableDates starting from January 2023
    // const startYear = new Date(createdate).getFullYear(); // Starting year
    // const endYear = new Date(createdate).getFullYear() + 15; // End year (current year + 1)

    // for (let year = startYear; year <= endYear; year++) {
    //   console.log(year);
    //   this.availableDatesYears.push(new Date(year, 0, 1));
    //   for (let month = 0; month < 12; month++) {
    //     // if(month <  new Date(createdate).getMonth()+1 && year !=  new Date(createdate).getFullYear())
    //     this.availableDatesMonthes.push(new Date(year, month, 1));
    //   }
    // }






    const user = localStorage.getItem("userid");
    if (user) {
      this.id = user;
      localStorage.setItem("userid", this.id);
      console.log("Come From Admin");
    } else {
      this.currentuser = JSON.parse(localStorage.getItem("currentuser"));
      console.log(this.currentuser)
      this.id = this.currentuser.clientid;
    }
     this.getclientbyid();
    this.getBranchByClientId();
  }

  ngOnInit() {
    this.loading = false
    this.InitForm()
    this.getallDepartment();
    this.primengConfig.ripple = true;
    this.filteredSearchType = this.SearchType.filter(item => item.id !== 6);
  }

  onTabChange(event){
    this.dataview = false
    this.datacompare = false;
    this.compareForm.reset();
    this.searchForm.reset();
    this.modulecat = [];
    this.lastfiltereddataDetailedScore = [];
    this.MonthsAndYearsBetweenDates = [];
    this.YearsBetweenDates = [];
    this.AnalysisAuditTotalScoreMonthly = [];
    this.AnalysisAuditTotalScoreYearly = [];
    this.departmentsKpiAnalysisObject = [];
    this.CommonMistakes = [];
    this.selectedMonthsDates = []; 
    this.selectedYearsDates = [];
  }






  getColumnType(field: string): string {
    return field === 'branch' ? 'text' : 'numeric';
  }



  resetFilters(dt: Table) {
    dt.clear();
    dt.reset();
  }





  exportPDF(dt: Table) {
    // Extract the filtered data or use the original data if no filter applied
    const filteredData = dt.filteredValue || this.datatableaudittotalscore;

    // Create a new jsPDF instance
    const doc = new jspdf.jsPDF();

    // Define column headers and data
    const headers = this.tableColumns.map(col => col.displayName);
    const data = filteredData.map(customer => this.tableColumns.map(col => customer[col.field]));

    // Generate the PDF
    autoTable(doc, {
      head: [headers],
      body: data,
      startY: 20, // Adjust the start position of the table on the page
      margin: { top: 20 },
      styles: { fontSize: 10 },
      didDrawPage: (data) => {
        // Header
        doc.setFontSize(18);
        doc.text('Data', data.settings.margin.left, 15);
      }
    });

    // Save the PDF
    doc.save('Data.pdf');
  }



  exportExcel(dt: any) {
    // Get the filtered data
    const filteredData = dt.filteredValue || this.datatableaudittotalscore;

    // Convert the filtered data to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    // Create a new workbook and append the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Data');

    // Save the workbook as an Excel file
    XLSX.writeFile(wb, 'data.xlsx');
  }






  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }


  onMonthsSelectionChange(event: any) {
    this.selectedMonthsDates = event;
    this.selectedMonthsDates = event.slice(0, 12);
    console.log('Selected dates:', this.selectedMonthsDates);
  }

  onYearsSelectionChange(event: any) {
    this.selectedYearsDates = event;
    this.selectedYearsDates = event.slice(0, 12);
    console.log('Selected dates:', this.selectedYearsDates);
  }

  CompareMonthsSelectionChange(event: any) {
    this.selectedMonthsDates = event;
    console.log('Selected dates:', this.selectedMonthsDates);
  }

  CompareYearsSelectionChange(event: any) {
    this.selectedYearsDates = event;
    console.log('Selected dates:', this.selectedYearsDates);
  }

  onSearchTypeChange(event: any) {
    this.SelectedSearchType = event.id;
    if (event.id == 1) {
      this.branchmulti = true;
      this.categoryactive = false;
    }
    else {
      if (event.id == 2) {
        this.categoryactive = true;
      }
      else {
        this.categoryactive = false;
      }
      // this.branchmulti = true;
      this.branchmulti = false;

    }
  }



  isMonthsDateDisabled(date: Date): boolean {
    return this.selectedMonthsDates.length >= 12 && !this.selectedMonthsDates.includes(date);
  }
  isYearssDateDisabled(date: Date): boolean {
    return this.selectedYearsDates.length >= 12 && !this.selectedYearsDates.includes(date);
  }

  onGroupByChange(event: string) {
    console.log(event);
    this.groupBy = event;
  }



  getBranchByClientId() {
    this.GeneralService.getBranchByClientId(this.id).then(res => {
      console.log(res)
      this.Branches = res;
      console.log(this.Branches, "our branches");
    })
  }

  getclientbyid() {
    this.GeneralService.getclientbyid(this.id).then((res) => {
      this.client = res;
      console.log(this.client)
      this.clientmodule = this.client[0].moudlerf;
      // console.log("clientmodule", this.clientmodule)
      let auditdate = new Date(
        Math.max.apply(
          null,
          this.audit.map(function (e) {
            return new Date(e.StartDate);
          })
        )
      );
    });
  }
  getcatbymodule(modname) {
    // console.log(modname)
    // console.log(this.clientmodule)
    let modulename = this.clientmodule.filter((res) => res.id == modname);
    this.modulecat = modulename[0].categories;

  }

  onActivityChange(event) {
    const value = event.target.value;
    if (value && value.trim().length) {
      const activity = parseInt(value);

      if (!isNaN(activity)) {
        this.table.filter(activity, 'activity', 'gte');
      }
    }
  }

  onDateSelect(value) {
    this.table.filter(this.formatDate(value), 'date', 'equals')
  }

  formatDate(date) {
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month < 10) {
      month = '0' + month;
    }

    if (day < 10) {
      day = '0' + day;
    }

    return date.getFullYear() + '-' + month + '-' + day;
  }






  exportChartAsImage(obj) {
    
    const chartImage = obj.toBase64Image(); 

    const link = document.createElement('a');
    link.download = 'audit-total-score-chart.png'; 
    link.href = chartImage;
    link.click();
  }




  InitForm() {
    this.searchForm = this.formBuilder.group({
      moduleid: ['', Validators.required],
      branches: [[], Validators.required],
      categories: ['']
    });

    this.compareForm = this.formBuilder.group({
      moduleid: ['', Validators.required],
      branches: [[], Validators.required],
      categories: ['']
    });
  }




  getYearsBetweenDates(dates) {
    const result = dates.map(dateString => {
      const year = new Date(dateString).getFullYear(); // Get the year from the date string
      return { year }; // Return an object with the year
    });

    return result;
  }

  async search() {
    this.AnalysisAuditTotalScoreMonthly = []
    this.MonthsAndYearsBetweenDates = []
    this.FilterdMonthes = []
    this.AnalysisAuditTotalScoreMonthlyDataSets = []
    this.AnalysisAuditTotalScoreDS = []
    this.branchesLabel = []
    try {
      // this.dataview = true;
      if (this.SelectedSearchType == 1) {
        if (this.groupBy == 'Monthly') {
          await this.getAnalysisAuditTotalScoreMonthly();


        }
        else {
          await this.getAnalysisAuditTotalScoreYearly();
        }

      }
      if (this.SelectedSearchType == 2) {
        if (this.groupBy == 'Monthly') {
          await this.getAnalysisAuditDetailedScoreMonthly();
        }
        else {
          await this.getAnalysisAuditDetailedScoreYearly();
        }

      }
      if (this.SelectedSearchType == 3) {
        if (this.groupBy == 'Monthly') {
          await this.getAnalysisDepartmentKpiMonthly();
        }
        else {
          await this.getAnalysisDepartmentKpiYearly();
        }
      }
      if (this.SelectedSearchType == 4) {
        if (this.groupBy == 'Monthly') {
          await this.getTaskCompilationMonthly();
        }
        else {
          await this.getTaskCompilationYearly();
        }

      }
      if (this.SelectedSearchType == 5) {
        if (this.groupBy == 'Monthly') {
          await this.getStandrdCompilationMonthly();
        }
        else {
          await this.getStandrdCompilationYearly();
        }

      }
      if (this.SelectedSearchType == 6) {
        if (this.groupBy == 'Monthly') {
          await this.getCommonMistakesMonthly();
        }
        else {
          await this.getCommonMistakesYearly();
        }

      }

    } catch (error) {
      // this.viewData=false
      console.error('Error fetching data:', error);
    }
  }


  openimage(url:any) {
    Swal.fire({
      imageUrl: url,
      // imageWidth: 500,
      // imageHeight: 400,
      imageAlt: 'Custom image',
    })
  }



  clear() {
    this.dataview = false
    this.datacompare = false;
    this.compareForm.reset();
    this.searchForm.reset();
    this.modulecat = [];
    this.lastfiltereddataDetailedScore = [];
    this.MonthsAndYearsBetweenDates = [];
    this.YearsBetweenDates = [];
    this.AnalysisAuditTotalScoreMonthly = [];
    this.AnalysisAuditTotalScoreYearly = [];
    this.departmentsKpiAnalysisObject = [];
    this.CommonMistakes = [];
    this.selectedMonthsDates = []; 
    this.selectedYearsDates = [];

  




  }

  open(url) {
    Swal.fire({
      imageUrl: url,
      imageAlt: 'Custom image',
    })
  }


  async onToggleChangeonToggleChangeAuditTotalScore(value) {
    if (value === 'Monthly') {
      if (this.AnalysisAuditTotalScoreMonthly.length != 0) {
        this.AuditTotalScoreChart(this.AnalysisAuditTotalScoreMonthly, "monthly");
      }
    }
    else {


      if (this.AnalysisAuditTotalScoreYearly.length != 0) {
        this.AuditTotalScoreChart(this.AnalysisAuditTotalScoreYearly, "yearly");
      }
      else {
        await this.getAnalysisAuditTotalScoreYearly()
        this.AuditTotalScoreChart(this.AnalysisAuditTotalScoreYearly, "yearly");
      }

    }
  }



  getallDepartment() {
    this.GeneralService.getallDepartment().then(res => {
      console.log(res);
      this.departments = res
    })
  }






  destroyChart(chart) {
    if (chart) {
      chart.destroy(); // Destroy the existing chart instance
      return chart = null;
    }
  }

  getMonthsAndYearsBetweenDates(dates) {
    let result = [];

    // Convert date strings to Date objects and sort them
    let sortedDates = dates.map(date => new Date(date)).sort((a, b) => a - b);

    // Handle edge case: if there are no dates or only one date
    if (sortedDates.length === 0) {
      return result;
    }

    // Initialize with the first date
    let startDate = new Date(sortedDates[0]);
    let endDate = new Date(startDate);

    // Iterate through the sorted dates to create month-year objects
    for (let i = 1; i < sortedDates.length; i++) {
      let currentDate = new Date(sortedDates[i]);

      // Check if currentDate is within the same month-year period as endDate
      if (currentDate.getMonth() === endDate.getMonth() && currentDate.getFullYear() === endDate.getFullYear()) {
        endDate = new Date(currentDate); // Update endDate to extend the period
      } else {
        // Generate month-year objects for the period from startDate to endDate
        while (startDate <= endDate) {
          result.push({ month: startDate.getMonth() + 1, year: startDate.getFullYear() });
          startDate.setMonth(startDate.getMonth() + 1);
        }

        // Update startDate and endDate for the next period
        startDate = new Date(currentDate);
        endDate = new Date(startDate);
      }
    }

    // Generate month-year objects for the last period
    while (startDate <= endDate) {
      result.push({ month: startDate.getMonth() + 1, year: startDate.getFullYear() });
      startDate.setMonth(startDate.getMonth() + 1);
    }

    return result;
  }


  //// get data for Analysis Audit Total Score
  async getAnalysisAuditTotalScoreMonthly() {
    try {
this.LoaderServiceService.show();
      const res = await this.GeneralService.getAnalysisAuditTotalScoreMonthly(this.searchForm.value, this.id);
      this.MonthsAndYearsBetweenDates = this.getMonthsAndYearsBetweenDates(this.selectedMonthsDates);
      if (Array.isArray(res) && res.length > 0) {
        this.AnalysisAuditTotalScoreMonthly = [];

        for (let i = 0; i < res.length; i++) {
          const item = res[i];
          if (item && item.branches.length != 0) { // Add null check for item and item.branches
            console.log(item);
            // Filter branches for each item separately
            const filteredItem = {
              clientid: item.clientid,
              moduleid: item.moduleid,
              branches: []
            };
            item.branches.forEach(branch => {
              if (this.searchForm.get('branches').value.length != 0) {
                var IncludeBranch = this.searchForm.get('branches').value.filter(x => x == branch.branchid);
                if (IncludeBranch.length != 0) {
                  for (let i = branch.monthes.length - 1; i >= 0; i--) {
                    const element = branch.monthes[i];
                    const month = this.MonthsAndYearsBetweenDates.some(date =>
                      date.month === element.month && date.year === element.year
                    );

                    if (!month) {
                      branch.monthes.splice(i, 1);
                    }
                  }

                  const filteredBranch = {
                    branchid: branch.branchid,
                    monthes: branch.monthes
                  };

                  // Add the branch to filteredItem if it has some monthes after filtering
                  if (branch.monthes.length > 0) {
                    filteredItem.branches.push(filteredBranch);
                  }
                }
              } else {
                for (let i = branch.monthes.length - 1; i >= 0; i--) {
                  const element = branch.monthes[i];
                  const month = this.MonthsAndYearsBetweenDates.some(date =>
                    date.month === element.month && date.year === element.year
                  );
                  if (!month) {
                    branch.monthes.splice(i, 1);
                  }
                }
                const filteredBranch = {
                  branchid: branch.branchid,
                  monthes: branch.monthes
                };

                // Add the branch to filteredItem if it has some monthes after filtering
                if (branch.monthes.length > 0) {
                  filteredItem.branches.push(filteredBranch);
                }
              }
            });

            // Add the filtered item to AnalysisAuditTotalScoreMonthly if it has branches
            if (filteredItem.branches.length > 0) {
              this.AnalysisAuditTotalScoreMonthly.push(filteredItem);
            }
          } else {
            console.error(`Branches property is undefined for item at index ${i}.`);
          }
        }
        
        this.viewData = await this.AnalysisAuditTotalScoreMonthly.length > 0;
        setTimeout(() => {
          
          this.AuditTotalScoreChart(this.AnalysisAuditTotalScoreMonthly, 'monthly');
        }, 2000);
      }

  
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }
  async getAnalysisAuditTotalScoreYearly() {
    this.LoaderServiceService.show();

    try {
      const res = await this.GeneralService.getAnalysisAuditTotalScoreYearly(this.searchForm.value, this.id);
      this.YearsBetweenDates = this.getYearsBetweenDates(this.selectedYearsDates);
      console.log(this.YearsBetweenDates, "this our years past dates");
      // Check if res is an array and not empty
      if (Array.isArray(res) && res.length > 0) {
        // Clear the AnalysisAuditTotalScoreMonthly array before populating it with filtered results
        this.AnalysisAuditTotalScoreYearly = [];

        // Process each element in the res array
        for (let i = 0; i < res.length; i++) {
          const item = res[i];
          if (item && item.branches.length != 0) { // Add null check for item and item.branches
            console.log(item);
            // Filter branches for each item separately
            const filteredItem = {
              clientid: item.clientid,
              moduleid: item.moduleid,
              branches: []
            };
            item.branches.forEach(branch => {
              if (this.searchForm.get('branches').value.length != 0) {
                var IncludeBranch = this.searchForm.get('branches').value.filter(x => x == branch.branchid);
                if (IncludeBranch.length != 0) {
                  for (let i = branch.years.length - 1; i >= 0; i--) {
                    const element = branch.years[i];
                    const year = this.YearsBetweenDates.some(date =>
                      date.year === element.year
                    );
                    if (!year) {
                      branch.years.splice(i, 1);
                    }
                  }
                  const filteredBranch = {
                    branchid: branch.branchid,
                    years: branch.years
                  };
                  // Add the branch to filteredItem if it has some monthes after filtering
                  if (branch.years.length > 0) {
                    filteredItem.branches.push(filteredBranch);
                  }
                }
              } else {
                for (let i = branch.years.length - 1; i >= 0; i--) {
                  const element = branch.years[i];
                  const year = this.YearsBetweenDates.some(date =>
                    date.year === element.year
                  );
                  if (!year) {
                    branch.years.splice(i, 1);
                  }
                }
                const filteredBranch = {
                  branchid: branch.branchid,
                  years: branch.years
                };
                // Add the branch to filteredItem if it has some monthes after filtering
                if (branch.years.length > 0) {
                  filteredItem.branches.push(filteredBranch);
                }
              }
            });
            // Add the filtered item to AnalysisAuditTotalScoreMonthly if it has branches
            if (filteredItem.branches.length > 0) {
              this.AnalysisAuditTotalScoreYearly.push(filteredItem);
            }
          } else {
            console.error(`Branches property is undefined for item at index ${i}.`);
          }
        }
      } else {
        console.error('Response is not an array or is empty.');
      }
      this.viewData = await this.AnalysisAuditTotalScoreYearly.length > 0; // Update viewData based on whether AnalysisAuditTotalScoreMonthly has data
      console.log(this.AnalysisAuditTotalScoreYearly);
      ///خطـأ ولكن لا يوجد بديل  setTimeout المفترض     
      // if (this.viewData) {
      //   this.AuditTotalScoreChart(this.AnalysisAuditTotalScoreMonthly);
      // }
      setTimeout(() => {
        this.viewData = true; // Set to true after some time or based on certain conditions
        this.AuditTotalScoreChart(this.AnalysisAuditTotalScoreYearly, 'yearly');
      }, 2000);
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }

  AuditTotalScoreChart(AnalysisAuditTotalScore, groupBy): void {
    this.chartAnalysisAuditTotalScore = this.destroyChart(this.chartAnalysisAuditTotalScore);
    Chart.register(ChartDataLabels);
    const ctx = document.getElementById('AuditTotalScoreChart') as HTMLCanvasElement;
    this.originalScores = [];
    this.processedData = [];
    this.AnalysisAuditTotalScoreDS = []
    this.branchesLabel = []
  
    if (groupBy == "monthly") {
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      
      // Sorting function for months
      const sortMonthYear = (a, b) => {
        const monthYearA = a.split(' ');
        const monthYearB = b.split(' ');
        const yearA = parseInt(monthYearA[1]);
        const yearB = parseInt(monthYearB[1]);
        const monthA = monthNames.indexOf(monthYearA[0]);
        const monthB = monthNames.indexOf(monthYearB[0]);
        
        if (yearA !== yearB) return yearA - yearB;
        return monthA - monthB;
      };
  
      AnalysisAuditTotalScore?.forEach(clientData => {
        clientData.branches?.forEach(branch => {
          const branchName = this.Branches.filter(x => x.id == branch.branchid)[0].name;
          this.branchesLabel.push(branchName);
          branch.monthes.forEach(monthData => {
            const monthName = monthNames[monthData.month - 1];
            const monthYear = `${monthName} ${monthData.year}`;
            const existingMonthYearIndex = this.processedData.findIndex(
              item => item.namemonth === monthYear
            );
  
            const formattedScorePercent = parseInt(monthData.scorepercent);
  
            if (existingMonthYearIndex != -1) {
              this.processedData[existingMonthYearIndex].data.push(formattedScorePercent);
              this.originalScores[existingMonthYearIndex].push(monthData.scorepercent.toFixed(2));
            } else {
              this.processedData.push({
                namemonth: monthYear,
                data: [formattedScorePercent],
              });
              this.originalScores.push([monthData.scorepercent.toFixed(2)]);
            }
          });
        });
      });
  
      // Sort processedData and originalScores by month and year
      const sortedIndices = this.processedData
        .map((_, index) => index)
        .sort((a, b) => sortMonthYear(this.processedData[a].namemonth, this.processedData[b].namemonth));
  
      this.processedData = sortedIndices.map(index => this.processedData[index]);
      this.originalScores = sortedIndices.map(index => this.originalScores[index]);
  
      this.processedData.forEach((element, index) => {
        this.AnalysisAuditTotalScoreDS.push({
          label: element.namemonth,
          data: element.data,
          backgroundColor: [this.colorarray[index]],
          borderWidth: 1,
          maxBarThickness: 80, // ✅ زيادة سمك الأعمدة
          barPercentage: 0.9, // ✅ عرض مناسب للأعمدة
          categoryPercentage: 0.9 // ✅ توزيع جيد داخل المحاور
        });
      });
    }
    else {
      // Sorting function for years
      const sortYears = (a, b) => parseInt(a) - parseInt(b);
  
      AnalysisAuditTotalScore?.forEach(clientData => {
        clientData.branches?.forEach(branch => {
          const branchName = this.Branches.filter(x => x.id == branch.branchid)[0].name;
          this.branchesLabel.push(branchName);
          branch.years?.forEach(yearData => {
            const Year = `${yearData.year}`;
            const existingYearIndex = this.processedData.findIndex(
              item => item.year === Year
            );
  
            const formattedScorePercent = parseInt(yearData.scorepercent);
  
            if (existingYearIndex != -1) {
              this.processedData[existingYearIndex].data.push(formattedScorePercent);
              this.originalScores[existingYearIndex].push(yearData.scorepercent.toFixed(2));
            } else {
              this.processedData.push({
                year: Year,
                data: [formattedScorePercent],
              });
              this.originalScores.push([yearData.scorepercent.toFixed(2)]);
            }
          });
        });
      });
  
      // Sort processedData and originalScores by year
      const sortedIndices = this.processedData
        .map((_, index) => index)
        .sort((a, b) => sortYears(this.processedData[a].year, this.processedData[b].year));
  
      this.processedData = sortedIndices.map(index => this.processedData[index]);
      this.originalScores = sortedIndices.map(index => this.originalScores[index]);
  
      this.processedData.forEach((element, index) => {
        this.AnalysisAuditTotalScoreDS.push({
          label: element.year,
          data: element.data,
          backgroundColor: [this.colorarray[index]],
          borderWidth: 1,
        });
      });
    }
  
    if(this.AnalysisAuditTotalScoreDS.length != 0){
      this.LoaderServiceService.hide();
      this.dataview = true;
    }else{
      this.LoaderServiceService.hide();
      this.GeneralService.fireEmpty();
    }
  
        console.log(this.AnalysisAuditTotalScoreDS);
    this.chartAnalysisAuditTotalScore = new Chart(ctx, {
      type: 'bar',
      data: {
        datasets: this.AnalysisAuditTotalScoreDS
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'x',
        plugins: {
         
          title: {
            display: true,
            position: 'bottom',
            text: ''
          },
          tooltip: {
            enabled: true, // Enable the default tooltip
            callbacks: { // Customize the tooltip content
              label: (context) => {
                const datasetIndex = context.datasetIndex;
                const dataIndex = context.dataIndex;
                const originalValue = this.originalScores[datasetIndex][dataIndex];
                return `${context.dataset.label}: ${originalValue}`;
              }
            }
          },
          datalabels: { // Plugin for displaying data labels
            anchor: 'center',
            align: 'center',
            color: 'black', // Text color
            font: {
              size: 14 // Font size
            },
            formatter: function (value: any) { // Format function for the data labels
              return value; // Display the value as it is
            }
          }
        },
        scales: {
          x: {
            labels: this.branchesLabel,
            grid: {
            },
            ticks: {
              color: 'black' // Change the color of tick marks on X scale
            }
          },
          y: {
            beginAtZero: true,
            min: 0, // Set minimum value
            max: 100,
          }
        }
      }
    });
  
  }

//   AuditTotalScoreChart(AnalysisAuditTotalScore, groupBy): void {
    
//     this.chartAnalysisAuditTotalScore = this.destroyChart(this.chartAnalysisAuditTotalScore);
//     Chart.register(ChartDataLabels);
//     const ctx = document.getElementById('AuditTotalScoreChart') as HTMLCanvasElement;
//     this.originalScores = [];
//     this.processedData = [];
//     this.AnalysisAuditTotalScoreDS = []
//     this.branchesLabel = []
//     if (groupBy == "monthly") {
//       const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//       AnalysisAuditTotalScore?.forEach(clientData => {
//         clientData.branches?.forEach(branch => {
//           const branchName = this.Branches.filter(x => x.id == branch.branchid)[0].name;
//           this.branchesLabel.push(branchName);
//           branch.monthes.forEach(monthData => {
//             const monthName = monthNames[monthData.month - 1];
//             const monthYear = `${monthName} ${monthData.year}`;
//             const existingMonthYearIndex = this.processedData.findIndex(
//               item => item.namemonth === monthYear
//             );

//             const formattedScorePercent = parseInt(monthData.scorepercent);

//             if (existingMonthYearIndex != -1) {
//               this.processedData[existingMonthYearIndex].data.push(formattedScorePercent);
//               this.originalScores[existingMonthYearIndex].push(monthData.scorepercent.toFixed(2));
//             } else {
//               this.processedData.push({
//                 namemonth: monthYear,
//                 data: [formattedScorePercent],
//               });
//               this.originalScores.push([monthData.scorepercent.toFixed(2)]);
//             }
//           });
//         });
//       });

//       console.log(this.processedData);
//       this.processedData.forEach((element, index) => {
//         this.AnalysisAuditTotalScoreDS.push({
//           label: element.namemonth,
//           data: element.data,
//           backgroundColor: [this.colorarray[index]],
//           borderWidth: 1,
//         });
//       });

//     }
//     else {
//       AnalysisAuditTotalScore?.forEach(clientData => {
//         clientData.branches?.forEach(branch => {
//           const branchName = this.Branches.filter(x => x.id == branch.branchid)[0].name;
//           this.branchesLabel.push(branchName);
//           branch.years?.forEach(yearData => {
//             const Year = `${yearData.year}`;
//             const existingYearIndex = this.processedData.findIndex(
//               item => item.year === Year
//             );

//             const formattedScorePercent = parseInt(yearData.scorepercent);

//             if (existingYearIndex != -1) {
//               this.processedData[existingYearIndex].data.push(formattedScorePercent);
//               this.originalScores[existingYearIndex].push(yearData.scorepercent.toFixed(2));
//             } else {
//               this.processedData.push({
//                 year: Year,
//                 data: [formattedScorePercent],
//               });
//               this.originalScores.push([yearData.scorepercent.toFixed(2)]);
//             }
//           });
//         });
//       });

//       this.processedData.forEach((element, index) => {
//         this.AnalysisAuditTotalScoreDS.push({
//           label: element.year,
//           data: element.data,
//           backgroundColor: [this.colorarray[index]],
//           borderWidth: 1,
//         });
//       });

//     }
// if(this.AnalysisAuditTotalScoreDS.length != 0){
//    this.LoaderServiceService.hide();
//   this.dataview = true;
// }else{
//   this.LoaderServiceService.hide();
//   this.GeneralService.fireEmpty();
// }


//     console.log(this.AnalysisAuditTotalScoreDS);
//     this.chartAnalysisAuditTotalScore = new Chart(ctx, {
//       type: 'bar',
//       data: {
//         datasets: this.AnalysisAuditTotalScoreDS
//       },
//       options: {
//         responsive: true,
//         maintainAspectRatio: false,
//         indexAxis: 'x',
//         plugins: {
         
//           title: {
//             display: true,
//             position: 'bottom',
//             text: ''
//           },
//           tooltip: {
//             enabled: true, // Enable the default tooltip
//             callbacks: { // Customize the tooltip content
//               label: (context) => {
//                 const datasetIndex = context.datasetIndex;
//                 const dataIndex = context.dataIndex;
//                 const originalValue = this.originalScores[datasetIndex][dataIndex];
//                 return `${context.dataset.label}: ${originalValue}`;
//               }
//             }
//           },
//           datalabels: { // Plugin for displaying data labels
//             anchor: 'center',
//             align: 'center',
//             color: 'black', // Text color
//             font: {
//               size: 14 // Font size
//             },
//             formatter: function (value: any) { // Format function for the data labels
//               return value; // Display the value as it is
//             }
//           }
//         },
//         scales: {
//           x: {
//             labels: this.branchesLabel,
//             grid: {
//             },
//             ticks: {
//               color: 'black' // Change the color of tick marks on X scale
//             }
//           },
//           y: {
//             beginAtZero: true,
//             min: 0, // Set minimum value
//             max: 100,
//           }
//         }
//       }
//     });
//     console.log('Chart instance:', this.chartAnalysisAuditTotalScore);





   

//   }
  ///// end chart  Analysis Audit Total Score

  //// get data for Analysis Audit Detailed Score

  async getAnalysisAuditDetailedScoreMonthly() {
    try {
this.LoaderServiceService.show();
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      const res = await this.GeneralService.getAnalysisAuditDetailedScoreMonthly(this.searchForm.value, this.id)
      this.MonthsAndYearsBetweenDates = this.getMonthsAndYearsBetweenDates(this.selectedMonthsDates);
      let x = res[0];
      let filteredresualt = x.cats.filter(item => item.category_name === this.searchForm.get('categories').value);

      filteredresualt = filteredresualt[0].months.filter(item =>
        this.MonthsAndYearsBetweenDates.some(criteria =>
          item.year === criteria.year && item.month === criteria.month));
      this.lastfiltereddataDetailedScore = [];
      filteredresualt.forEach(months => {
        months.branches.forEach(barnch => {
          if (barnch.branchid === this.searchForm.get('branches').value) {
            this.lastfiltereddataDetailedScore.push({
              month: months.month,
              year: months.year,
              score: barnch.scorepercent,
              scoredecmail: ((barnch.net_score * 100) / barnch.fullscore).toFixed(2)
            })
          }
        });
      });

      console.log(this.lastfiltereddataDetailedScore);

      this.lastfiltereddataDetailedScore.sort((a, b) => {
        // First, compare years
        if (a.year !== b.year) {
          return a.year - b.year;
        } else {
          // If years are the same, compare months
          return a.month - b.month;
        }
      });

      var chartdata = [];
      this.lastfiltereddataDetailedScore.forEach((element, index) => {
        chartdata.push({
          label: monthNames[element.month - 1] + ' ' + element.year,
          data: [element.score],
          backgroundColor: [this.colorarray[index]],
          borderWidth: 1,
          maxBarThickness: 80, // ✅ زيادة سمك الأعمدة
          barPercentage: 0.9, // ✅ عرض مناسب للأعمدة
          categoryPercentage: 0.9, // ✅ توزيع جيد داخل المحاور
        })
      });

      console.log(this.lastfiltereddataDetailedScore);
      await this.AuditDetailedScoreChart(chartdata);

    } catch (error) {
      console.error('Error fetching or processing data:', error);
    }
  }
  getBranchName(branchid: string): string | undefined {
    const branchInfoItem = this.Branches.find(item => item.id === branchid);
    return branchInfoItem?.name;
  }
  async getAnalysisAuditDetailedScoreYearly() {
    try {
      this.LoaderServiceService.show();
      const res = await this.GeneralService.getAnalysisAuditDetailedScoreYearly(this.searchForm.value, this.id);
      this.YearsBetweenDates = this.getYearsBetweenDates(this.selectedYearsDates);
      let x = res[0];
      let filteredresualt = x.cats.filter(item => item.category_name === this.searchForm.get('categories').value);
      filteredresualt = filteredresualt[0].years.filter(item =>
        this.YearsBetweenDates.some(criteria =>
          item.year === criteria.year));
      this.lastfiltereddataDetailedScore = [];
      filteredresualt.forEach(years => {
        years.branches.forEach(barnch => {
          if (barnch.branchid === this.searchForm.get('branches').value) {
            this.lastfiltereddataDetailedScore.push({
              year: years.year,
              score: barnch.scorepercent,
              scoredecmail: ((barnch.net_score * 100) / barnch.fullscore).toFixed(2)
            })
          }
        });
      });

      console.log(this.lastfiltereddataDetailedScore);

      this.lastfiltereddataDetailedScore.sort((a, b) => {
        // First, compare years
        if (a.year !== b.year) {
          return a.year - b.year;
        } else {
          return a.month - b.month;
        }
      });

      var chartdata = [];
      this.lastfiltereddataDetailedScore.forEach((element, index) => {
        chartdata.push({
          label: element.year,
          data: [element.score],
          backgroundColor: [this.colorarray[index]],
          borderWidth: 1,
          maxBarThickness: 80, // ✅ زيادة سمك الأعمدة
          barPercentage: 0.9, // ✅ عرض مناسب للأعمدة
          categoryPercentage: 0.9, // ✅ توزيع جيد داخل المحاور
        })
      });

      console.log(this.lastfiltereddataDetailedScore);
      await this.AuditDetailedScoreChart(chartdata);


    } catch (error) {
      console.error('Error fetching or processing data:', error);
    }
  }

  AuditDetailedScoreChart(filterdata): void {

    this.chartAuditDetailedScore = this.destroyChart(this.chartAuditDetailedScore);
    Chart.register(ChartDataLabels);
    const ctx = document.getElementById('AuditDetailedScoreChart') as HTMLCanvasElement;
    console.log(ctx);
    if(filterdata.length != 0){
      this.LoaderServiceService.hide();
      this.dataview = true;
    }else{
      this.LoaderServiceService.hide();
      this.GeneralService.fireEmpty();
    }

    this.chartAuditDetailedScore = new Chart(ctx, {
      type: 'bar',
      data: {
        datasets: filterdata
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'x',
        plugins: {
          
          title: {
            display: true,
            position: 'bottom',
            text: ''
          },
          tooltip: {
            enabled: true, // Enable the default tooltip
            callbacks: { // Customize the tooltip content
              label: (context) => {
                const datasetIndex = context.datasetIndex;
                const originalValue = this.lastfiltereddataDetailedScore[datasetIndex].scoredecmail;
                return `${context.dataset.label}: ${originalValue}`;
              }
            }
          },
          datalabels: { // Plugin for displaying data labels
            anchor: 'center',
            align: 'center',
            color: 'black', // Text color
            font: {
              size: 14 // Font size
            },
            formatter: function (value: any) { // Format function for the data labels
              return value; // Display the value as it is
            }
          }
        },
        scales: {
          x: {
            labels: ["Category : " + this.searchForm.get('categories').value + ' ( Branch : ' + this.Branches.filter(item => item.id === this.searchForm.get('branches').value)[0].name + " )"],
            grid: {
            },
            ticks: {
              color: 'black' // Change the color of tick marks on X scale
            }
          },
          y: {
            beginAtZero: true,
            min: 0, // Set minimum value
            max: 100,
          }
        }
      }
    });
 


  }
  ///// end chart  Analysis Audit Total Score
  sortAndBuildData(data: any[]): any[] {
    const departmentOrderMap = new Map<string, number>(
      this.departments.map((dept, index) => [dept.id, index])
    );

    // Function to sort departments
    const sortDepartments = (departments: any[]) => {
      return departments.sort((a, b) => {
        const indexA = departmentOrderMap.get(a.departmentId) ?? Infinity;
        const indexB = departmentOrderMap.get(b.departmentId) ?? Infinity;
        return indexA - indexB;
      });
    };

    // Sort and build data
    const sortedData = data.map(entry => {
      let sortedEntry = { ...entry }; // Create a copy of the current entry
      // Apply sorting if the departments array exists
      if (sortedEntry[0]?.departments) {
        sortedEntry[0].departments = sortDepartments(sortedEntry[0].departments);
      }
      return sortedEntry; // Add the sorted entry to the result
    });

    return sortedData;


  }

  async getAnalysisDepartmentKpiMonthly() {
    this.transformedData =[];
    this.LoaderServiceService.show();
    try {
      this.LoaderServiceService.show();
      this.departmentsKpiAnalysisObject = [];
      this.MonthsAndYearsBetweenDates = this.getMonthsAndYearsBetweenDates(this.selectedMonthsDates);
      this.GeneralService.getDepartmentKpiMonthly(this.searchForm.value, this.id, this.MonthsAndYearsBetweenDates)
        .then(data => {
          data = data.filter(array => array.length > 0);
          console.log(data, "our Department Kpi Monthly");
          console.log(this.departments, "our department");
          var x = this.sortAndBuildData(data);
          console.log(x, "after sort");

          const uniqueDepartmentIds = new Set<string>();
          var labels = [];
          x.forEach(entry => {
            entry['0'].departments.forEach(department => {
              uniqueDepartmentIds.add(department.departmentId);
            });
          });

          labels = Array.from(uniqueDepartmentIds);
          var viewlabels = [];
          labels.map(id => {
            const department = this.departments.filter(d => d.id === id);
            if (department) {
              viewlabels.push(department[0].name)
            }
          });




          const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          // Loop through each month's data
          x.forEach((monthData, index) => {
            const month = monthNames[monthData['0'].month - 1];
            const year = monthData["0"].year;
            const label = `${month} ${year}`;

            let dataPoints = [];
            let dataPercentFixed2 = [];

            // Find the corresponding data for each department in this month
            viewlabels.forEach(department => {
              const departmentData = monthData["0"].departments.find(d => d.departmentName === department);
              if (departmentData) {
                dataPoints.push(departmentData.percent);
                dataPercentFixed2.push(departmentData.percentfixed2);
              } else {
                dataPoints.push("N,A"); // Add 0 if department data is missing
                dataPercentFixed2.push("N,A"); // Add 0 if department data is missing
              }
            });
            console.log(dataPoints, dataPercentFixed2)

            this.transformedData.push({
              label: label,
              data: dataPoints,
              datapercentfixed2: dataPercentFixed2,
              backgroundColor: [this.colorarray[index]], // You can customize the color here
              borderWidth: 1,
              maxBarThickness: 80, // ✅ زيادة سمك الأعمدة
              barPercentage: 0.9, // ✅ عرض مناسب للأعمدة
              categoryPercentage: 0.9, // ✅ توزيع جيد داخل المحاور
            });
          });


          this.DepartmentKpiChart(this.transformedData, viewlabels)
        })
        .catch(error => {
          console.error('Error:', error);
          // Handle error
        });
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }

  async getAnalysisDepartmentKpiYearly() {
    this.LoaderServiceService.show();

    this.transformedData =[];
    try {
      this.LoaderServiceService.show();
      this.departmentsKpiAnalysisObject = [];
      this.YearsBetweenDates = this.getYearsBetweenDates(this.selectedYearsDates);
      this.GeneralService.getDepartmentKpiYearly(this.searchForm.value, this.id, this.YearsBetweenDates)
        .then(data => {
          data = data.filter(array => array.length > 0);
          var x = this.sortAndBuildData(data);
          // console.log(x);
          // this.transformedData = x.map((entry, index) => {
          //   const year = entry['0'].year;
          //   const date = `${year}`;
          //   const data = entry['0'].departments.map(department => department.percent);
          //   const datapercentfixed2 = entry['0'].departments.map(department => department.percentfixed2);
          //   return {
          //     label: date,
          //     data: data,
          //     backgroundColor: [this.colorarray[index]],
          //     borderWidth: 1,
          //     datapercentfixed2: datapercentfixed2
          //   };
          // });

          const uniqueDepartmentIds = new Set<string>();
          var labels = [];
          x.forEach(entry => {
            entry['0'].departments.forEach(department => {
              uniqueDepartmentIds.add(department.departmentId);
            });
          });

          labels = Array.from(uniqueDepartmentIds);
          var viewlabels = [];
          labels.map(id => {
            const department = this.departments.filter(d => d.id === id);
            if (department) {
              viewlabels.push(department[0].name)
            }
          });


          x.forEach((monthData, index) => {
            const year = monthData["0"].year;
            const label = `${year}`;

            let dataPoints = [];
            let dataPercentFixed2 = [];

            // Find the corresponding data for each department in this month
            viewlabels.forEach(department => {
              const departmentData = monthData["0"].departments.find(d => d.departmentName === department);
              if (departmentData) {
                dataPoints.push(departmentData.percent);
                dataPercentFixed2.push(departmentData.percentfixed2);
              } else {
                dataPoints.push("N,A"); // Add 0 if department data is missing
                dataPercentFixed2.push("N,A"); // Add 0 if department data is missing
              }
            });
            console.log(dataPoints, dataPercentFixed2)

            this.transformedData.push({
              label: label,
              data: dataPoints,
              datapercentfixed2: dataPercentFixed2,
              backgroundColor: [this.colorarray[index]], // You can customize the color here
              borderWidth: 1
            });
          });

          this.DepartmentKpiChart(this.transformedData, viewlabels)
        })
        .catch(error => {
          console.error('Error:', error);
          // Handle error
        });
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }

  DepartmentKpiChart(data, labels): void {
    this.chartDepartmentKpiScore = this.destroyChart(this.chartDepartmentKpiScore);
    Chart.register(ChartDataLabels);
    const ctx = document.getElementById('DepartmentKpiChart') as HTMLCanvasElement;
    console.log(ctx);
    if(data.length != 0){
      this.LoaderServiceService.hide();
      this.dataview = true;
    }else{
      this.LoaderServiceService.hide();
      this.GeneralService.fireEmpty();
    }
    this.chartDepartmentKpiScore = new Chart(ctx, {
      type: 'bar',
      data: {
        datasets: data
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'x',
        plugins: {
        
          title: {
            display: true,
            position: 'bottom',
            text: ''
          },
          tooltip: {
            enabled: true, // Enable the default tooltip
            callbacks: { // Customize the tooltip content
              label: (context) => {
                const datasetIndex = context.datasetIndex;
                const dataIndex = context.dataIndex;
                const originalValue = this.transformedData[datasetIndex].datapercentfixed2[dataIndex];
                return `${context.dataset.label}: ${originalValue}`;
              }
            }
          },
          datalabels: { // Plugin for displaying data labels
            anchor: 'center',
            align: 'center',
            color: 'black', // Text color
            font: {
              size: 14 // Font size
            },
            formatter: function (value: any) { // Format function for the data labels
              return value; // Display the value as it is
            }
          }
        },
        scales: {
          x: {
            labels: labels,
            grid: {
            },
            ticks: {
              color: 'black' // Change the color of tick marks on X scale
            }
          },
          y: {
            beginAtZero: true,
            min: 0, // Set minimum value
            max: 100,
          }
        }
      }
    });



  }

  async getTaskCompilationMonthly() {
    this.LoaderServiceService.show();

    try {
      this.MonthsAndYearsBetweenDates = this.getMonthsAndYearsBetweenDates(this.selectedMonthsDates);
      this.GeneralService.getTaskCompilationMonthly(this.searchForm.value, this.id, this.MonthsAndYearsBetweenDates)
        .then(data => {
          data = data.filter(array => array.length > 0);
          const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          var opendatapercent = []
          var closedatapercent = []
          var opendatapercentdecmailfixed = []
          var closedatapercentdecmailfixed = []
          var months = [];
          data.forEach(arr => {
            arr.forEach(item => {
              var openpercentdecmail = "";
              var closepercentdecmail = "";

              const month = monthNames[item.month - 1];
              const year = item.year;
              months.push(`${month} ${year}`);
              opendatapercent.push(item.openscore);
              closedatapercent.push(item.closescore);
              openpercentdecmail = ((item.opencount * 100) / item.totalcount).toFixed(2);
              opendatapercentdecmailfixed.push(openpercentdecmail);
              closepercentdecmail = ((item.closecount * 100) / item.totalcount).toFixed(2);
              closedatapercentdecmailfixed.push(closepercentdecmail);
            });
          });
          this.TaskCompilationChart(opendatapercent, closedatapercent, opendatapercentdecmailfixed, closedatapercentdecmailfixed, months);
        })
        .catch(error => {
          console.error('Error:', error);
          // Handle error
        });
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }

  async getTaskCompilationYearly() {
    this.LoaderServiceService.show();

    try {
      this.YearsBetweenDates = this.getYearsBetweenDates(this.selectedYearsDates);
      this.GeneralService.getTaskCompilationYearly(this.searchForm.value, this.id, this.YearsBetweenDates)
        .then(data => {
          data = data.filter(array => array.length > 0);
          var opendatapercent = []
          var closedatapercent = []
          var opendatapercentdecmailfixed = []
          var closedatapercentdecmailfixed = []
          var years = [];
          data.forEach(arr => {
            arr.forEach(item => {
              var openpercentdecmail = "";
              var closepercentdecmail = "";
              const year = item.year;
              years.push(`${year}`);
              opendatapercent.push(item.openscore);
              closedatapercent.push(item.closescore);
              openpercentdecmail = ((item.opencount * 100) / item.totalcount).toFixed(2);
              opendatapercentdecmailfixed.push(openpercentdecmail);
              closepercentdecmail = ((item.closecount * 100) / item.totalcount).toFixed(2);
              closedatapercentdecmailfixed.push(closepercentdecmail);
            });
          });
          this.TaskCompilationChart(opendatapercent, closedatapercent, opendatapercentdecmailfixed, closedatapercentdecmailfixed, years);
        })
        .catch(error => {
          console.error('Error:', error);
          // Handle error
        });
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }

  TaskCompilationChart(opendatapercent, closedatapercent, opendatapercentdecmailfixed, closedatapercentdecmailfixed, years): void {
    this.chartTaskCompilationScore = this.destroyChart(this.chartTaskCompilationScore);

    Chart.register(ChartDataLabels);
    const ctx = document.getElementById('TaskCompilationChart') as HTMLCanvasElement;
    console.log(ctx);
    if(opendatapercent.length != 0 &&  closedatapercent.length != 0){
      this.LoaderServiceService.hide();
      this.dataview = true;
    }else{
      this.LoaderServiceService.hide();
      this.GeneralService.fireEmpty();
    }
    this.chartTaskCompilationScore = new Chart(ctx, {
      type: 'bar',
      data: {
        datasets: [{
          label: 'open',
          data: opendatapercent,
          backgroundColor: [
            'rgba(0,0,123,1)'
          ],
          borderWidth: 1,
          maxBarThickness: 80, // ✅ زيادة سمك الأعمدة
          barPercentage: 0.9, // ✅ عرض مناسب للأعمدة
          categoryPercentage: 0.9, // ✅ توزيع جيد داخل المحاور
        },
        {
          label: 'close',
          data: closedatapercent,
          backgroundColor: [
            'rgba(255, 160, 0,1)'
          ],
          borderWidth: 1,
          maxBarThickness: 80, // ✅ زيادة سمك الأعمدة
          barPercentage: 0.9, // ✅ عرض مناسب للأعمدة
          categoryPercentage: 0.9, // ✅ توزيع جيد داخل المحاور
        }
        ]
      },
      options: {
        indexAxis: 'x',
        plugins: {
          tooltip: {
            enabled: true, // Enable the default tooltip
            callbacks: { // Customize the tooltip content
              label: (context) => {
                const datasetIndex = context.datasetIndex;
                const dataIndex = context.dataIndex;
                var originalValue;
                if (context.dataset.label == "open") {
                  originalValue = opendatapercentdecmailfixed[dataIndex];
                } else {
                  originalValue = closedatapercentdecmailfixed[dataIndex];
                }
                return `${context.dataset.label}: ${originalValue}`;
              }
            }
          },
          datalabels: { // Plugin for displaying data labels
            anchor: 'center',
            align: 'center',
            color: 'white', // Text color
            font: {
              size: 14 // Font size
            },
            formatter: function (value: any) { // Format function for the data labels
              return value; // Display the value as it is
            }
          }
        },
        scales: {

          x: {
            labels: years,
            grid: {
              // color: 'rgba(60,60,60, 1)' // Change the border color for X scale
            },
            ticks: {
              color: 'black' // Change the color of tick marks on X scale
            }
          },
          y: {
            beginAtZero: true,
            min: 0, // Set minimum value
            max: 100,
          }
        }
      }
    });



  }

  async getStandrdCompilationMonthly() {
    this.LoaderServiceService.show();

    try {
      this.LoaderServiceService.show();

      this.MonthsAndYearsBetweenDates = this.getMonthsAndYearsBetweenDates(this.selectedMonthsDates);
      this.GeneralService.getStandrdCompilationMonthly(this.searchForm.value, this.id, this.MonthsAndYearsBetweenDates)
        .then(data => {
          console.log(data);
          data = data.filter(array => array.length > 0);
          const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          var c = []
          var nc = []
          var m = []
          var months = [];
          var cDecmail = [];
          var ncDecmail = [];
          var mDecmail = [];
          data.forEach(arr => {
            arr.forEach(item => {
              const month = monthNames[item.month - 1];
              const year = item.year;
              months.push(`${month} ${year}`);
              c.push(item.percentC);
              nc.push(item.percentNc);
              m.push(item.percentM);
              cDecmail.push(((item.countC * 100) / item.totalcount).toFixed(2));
              ncDecmail.push(((item.countNc * 100) / item.totalcount).toFixed(2));
              mDecmail.push(((item.countM * 100) / item.totalcount).toFixed(2));

            });
          });
          this.StandardCompilationChart(c, nc, m, cDecmail, ncDecmail, mDecmail, months);
        })
        .catch(error => {
          console.error('Error:', error);
          // Handle error
        });
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }

  async getStandrdCompilationYearly() {
    this.LoaderServiceService.show();

    try {
      this.LoaderServiceService.show();
      this.YearsBetweenDates = this.getYearsBetweenDates(this.selectedYearsDates);
      this.GeneralService.getStandrdCompilationYearly(this.searchForm.value, this.id, this.YearsBetweenDates)
        .then(data => {
          console.log(data);
          data = data.filter(array => array.length > 0);
          var c = []
          var nc = []
          var m = []
          var years = [];
          var cDecmail = [];
          var ncDecmail = [];
          var mDecmail = [];
          data.forEach(arr => {
            arr.forEach(item => {
              const year = item.year;
              years.push(`${year}`);
              c.push(item.percentC);
              nc.push(item.percentNc);
              m.push(item.percentM);
              cDecmail.push(((item.countC * 100) / item.totalcount).toFixed(2));
              ncDecmail.push(((item.countNc * 100) / item.totalcount).toFixed(2));
              mDecmail.push(((item.countM * 100) / item.totalcount).toFixed(2));

            });
          });
          this.StandardCompilationChart(c, nc, m, cDecmail, ncDecmail, mDecmail, years);
        })
        .catch(error => {
          console.error('Error:', error);
          // Handle error
        });
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }


  StandardCompilationChart(cRes, ncRes, mRes, cDecmail, ncDecmail, mDecmail, months): void {
    this.chartStandardCompilationScore = this.destroyChart(this.chartStandardCompilationScore);
    Chart.register(ChartDataLabels);
    const ctx = document.getElementById('StandardCompilationChart') as HTMLCanvasElement;
    console.log(ctx);

    if(cRes.length != 0 &&  ncRes.length != 0 && mRes.length != 0 ){
      this.LoaderServiceService.hide();
      this.dataview = true;
    }else{
      this.LoaderServiceService.hide();
      this.GeneralService.fireEmpty();
    }
    this.chartStandardCompilationScore = new Chart(ctx, {
      type: 'bar',
      data: {
        datasets: [{
          label: 'C',
          data: cRes,
          backgroundColor: [
            'rgba(0,0,123,1)'
          ],
          borderWidth: 1,
          maxBarThickness: 80, // ✅ زيادة سمك الأعمدة
          barPercentage: 0.9, // ✅ عرض مناسب للأعمدة
          categoryPercentage: 0.9, // ✅ توزيع جيد داخل المحاور
        },
        {
          label: 'M',
          data: mRes,
          backgroundColor: [
            'rgb(255, 160, 0)'
          ],
          borderWidth: 1,
          maxBarThickness: 80, // ✅ زيادة سمك الأعمدة
          barPercentage: 0.9, // ✅ عرض مناسب للأعمدة
          categoryPercentage: 0.9, // ✅ توزيع جيد داخل المحاور
        },
        {
          label: 'NC',
          data: ncRes,
          backgroundColor: [
            'rgba(255, 0, 0,1)'
          ],
          borderWidth: 1,
          maxBarThickness: 80, // ✅ زيادة سمك الأعمدة
          barPercentage: 0.9, // ✅ عرض مناسب للأعمدة
          categoryPercentage: 0.9, // ✅ توزيع جيد داخل المحاور
        }
        ]
      },
      options: {
        indexAxis: 'x',
        plugins: {
          tooltip: {
            enabled: true, // Enable the default tooltip
            callbacks: { // Customize the tooltip content
              label: (context) => {
                const datasetIndex = context.datasetIndex;
                const dataIndex = context.dataIndex;
                var originalValue;
                if (context.dataset.label == "C") {
                  originalValue = cDecmail[dataIndex];
                }
                if (context.dataset.label == "M") {
                  originalValue = mDecmail[dataIndex];
                }
                if (context.dataset.label == "NC") {
                  originalValue = ncDecmail[dataIndex];
                }

                return `${context.dataset.label}: ${originalValue}`;
              }
            }
          },
          datalabels: { // Plugin for displaying data labels
            anchor: 'center',
            align: 'center',
            color: 'white', // Text color
            font: {
              size: 14 // Font size
            },
            formatter: function (value: any) { // Format function for the data labels
              return value; // Display the value as it is
            }
          }
        },
        scales: {

          x: {
            labels: months,
            grid: {
              // color: 'rgba(60,60,60, 1)' // Change the border color for X scale
            },
            ticks: {
              color: 'black' // Change the color of tick marks on X scale
            }
          },

          y: {
            beginAtZero: true,
            min: 0, // Set minimum value
            max: 100,
          }
        }
      }
    });
    console.log('Chart instance:', this.chartAnalysisAuditTotalScore);
  }



  async getCommonMistakesMonthly() {
    this.CommonMistakes = [];
    this.dataview = true;
    try {
      this.MonthsAndYearsBetweenDates = this.getMonthsAndYearsBetweenDates(this.selectedMonthsDates);
      this.GeneralService.CommonMistakesMonthly(this.searchForm.value, this.id, this.MonthsAndYearsBetweenDates)
        .then(data => {
          const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          data = data.filter(array => array.length > 0);
          console.log(data);
          data.forEach((elment, index) => {
            var date = monthNames[elment[0].month - 1] + " " + elment[0].year;
            var object = this.groupQuestionsByCatname(elment[0].ques);
            data[index][0].ques = object;
            data[index][0].date = date;
          });

          this.CommonMistakes = data.map((branch) => {
            return {
              ...branch[0],
              ques: branch[0].ques.map((category) => {
                return {
                  ...category,
                  questions: category.questions.filter((question) => question.percent <= 50),
                };
              }),
            };
          });


          this.CommonMistakes = this.CommonMistakes.map((branch) => {
            return {
              ...branch,
              ques: branch.ques.filter((category) => category.questions.length > 0),
            };
          });


          this.CommonMistakes = this.CommonMistakes.filter(item => item.ques.length > 0);
          console.log(this.CommonMistakes);
        })
        .catch(error => {
          console.error('Error:', error);
          // Handle error
        });
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }


  async getCommonMistakesYearly() {
    this.dataview = true;
    this.CommonMistakes = [];
    try {
      this.YearsBetweenDates = this.getYearsBetweenDates(this.selectedYearsDates);
      this.GeneralService.CommonMistakesYearly(this.searchForm.value, this.id, this.YearsBetweenDates)
        .then(data => {
          data = data.filter(array => array.length > 0);
          console.log(data);
          data.forEach((elment, index) => {
            var date = elment[0].year;
            var object = this.groupQuestionsByCatname(elment[0].ques);
            data[index][0].ques = object;
            data[index][0].date = date;
          });

          this.CommonMistakes = data.map((branch) => {
            return {
              ...branch[0],
              ques: branch[0].ques.map((category) => {
                return {
                  ...category,
                  questions: category.questions.filter((question) => question.percent <= 50),
                };
              }),
            };
          });

          console.log(this.CommonMistakes);

          this.CommonMistakes = this.CommonMistakes.map((branch) => {
            return {
              ...branch,
              ques: branch.ques.filter((category) => category.questions.length > 0),
            };
          });


          this.CommonMistakes = this.CommonMistakes.filter(item => item.ques.length > 0);

        })
        .catch(error => {
          console.error('Error:', error);
          // Handle error
        });
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }




  groupQuestionsByCatname(data: any[]): any[] {
    // Transform the array of questions into the desired structure
    const groupedQuestions = data.reduce((acc: any[], question: any) => {
      const catname = question.catname;

      // Find if the category already exists in the accumulator
      let category = acc.find((item: any) => item.catname === catname);

      if (!category) {
        // If not found, create a new category entry
        category = {
          catname: catname,
          questions: []
        };
        acc.push(category);
      }

      // Add the question to the appropriate category
      category.questions.push({
        id: question.id,
        arabicname: question.arabicname,
        englishname: question.englishname,
        netscore: question.netscore,
        percent: question.percent,
        totalcount: question.totalcount,
        photourl: question.photourl,
        resualts: question.resualts,
        comment: question.comment
      });

      return acc;
    }, []);

    // Sort the categories by catname
    groupedQuestions.sort((a: any, b: any) => a.catname.localeCompare(b.catname));

    console.log(groupedQuestions);
    return groupedQuestions;
  }




  async searchcompare() {
    try {
      console.log(this.SelectedSearchType);
      this.datacompare = true;

      if (this.SelectedSearchType == 1) {
        if (this.groupBy == 'Monthly') {
          await this.getAnalysisAuditTotalScoreMonthlyCompare();
        }
        else {
          await this.getAnalysisAuditTotalScoreYearlyCompare();
        }

      }
      if (this.SelectedSearchType == 2) {
        if (this.groupBy == 'Monthly') {
          await this.getAnalysisAuditDetailedScoreMonthlyCompare();
        }
        else {
          await this.getAnalysisAuditDetailedScoreYearlyCompare();
        }

      }
      if (this.SelectedSearchType == 3) {
        if (this.groupBy == 'Monthly') {
          await this.getAnalysisDepartmentKpiMonthlyCompare();
        }
        else {
          await this.getAnalysisDepartmentKpiYearlyCompare();
        }
      }
      if (this.SelectedSearchType == 4) {
        if (this.groupBy == 'Monthly') {
          await this.getTaskCompilationMonthlyCompare();
        }
        else {
          await this.getTaskCompilationYearlyCompare();
        }

      }
      if (this.SelectedSearchType == 5) {
        if (this.groupBy == 'Monthly') {
          await this.getStandardCompilationMonthlyCompare();
        }
        else {
          await this.getStandardCompilationYearlyCompare();
        }

      }
   

    } catch (error) {
      // this.viewData=false
      console.error('Error fetching data:', error);
    }

  }

 




  ////// start
  async getAnalysisAuditTotalScoreMonthlyCompare() {
    this.allColumns=[];
    this.filter=[];
    this.tableColumns=[];
    try {
      const res = await this.GeneralService.getAnalysisAuditTotalScoreMonthly(this.compareForm.value, this.id);
      this.MonthsAndYearsBetweenDates = this.getMonthsAndYearsBetweenDates(this.selectedMonthsDates);
      const filteredBranches = res[0].branches.filter(branch => this.compareForm.value.branches.includes(branch.branchid));
      const result = this.filterBranchesByMonthAndYearAuditTotalScoreCompareMonthly(filteredBranches, this.MonthsAndYearsBetweenDates);
      const { allColumns, data } = this.transformDataAudittotalScoreCompareMonth(result, this.Branches);
      this.datatableaudittotalscore = data;
      console.log(this.datatableaudittotalscore, "month data");
      this.allColumns = allColumns;
      this.filter = this.allColumns.map(col => col.field);

      // Initialize tableColumns based on allColumns visibility
      this.tableColumns = this.allColumns.filter(col => col.visible).map(col => ({
        ...col,
        type: this.getColumnType(col.field)  // Dynamically set type
      }));
      setTimeout(() => {
      }, 2000);
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }
  filterBranchesByMonthAndYearAuditTotalScoreCompareMonthly(filteredBranches: any[], dates: { month: number, year: number }[]): any[] {
    // Create a Set of 'YYYY-MM' strings for the given dates
    const allowedDatesSet = new Set(
      dates.map(date => `${date.year}-${date.month.toString().padStart(2, '0')}`)
    );

    console.log(`Allowed dates set: ${JSON.stringify([...allowedDatesSet])}`); // Debugging line

    // Filter the branches
    return filteredBranches.map(branch => {
      console.log(`Processing branch: ${branch.branchid}`); // Debugging line

      const filteredMonthes = branch.monthes.filter(month => {
        const monthYearString = `${month.year}-${month.month.toString().padStart(2, '0')}`;
        console.log(`Checking month-year: ${monthYearString}`); // Debugging line

        const isIncluded = allowedDatesSet.has(monthYearString);
        console.log(`Is included: ${isIncluded}`); // Debugging line

        return isIncluded;
      });

      return {
        ...branch,
        monthes: filteredMonthes
      };
    });
  }

  transformDataAudittotalScoreCompareMonth(data: any[], branches: any[]): { allColumns: any[], data: any[] } {
    // Create a mapping from branch ID to branch name
    const branchNameMap = branches.reduce((map, branch) => {
      map[branch.id] = branch.name;
      return map;
    }, {} as { [id: string]: string });

    // Create a Set to hold unique month-year combinations
    const uniqueMonthYears = new Set<string>();

    // Populate the Set with month-year combinations
    data.forEach(branch => {
      branch.monthes.forEach(month => {
        const monthYear = `${month.month.toString().padStart(2, '0')}${month.year}`;
        uniqueMonthYears.add(monthYear);
      });
    });

    // Create columns array with a fixed first object
    const allColumns = [
      { field: 'branch', displayName: 'Branch', visible: true }
    ];

    // Add columns for each unique month-year combination
    uniqueMonthYears.forEach(monthYear => {
      const month = parseInt(monthYear.substring(0, 2), 10);
      const year = monthYear.substring(2);

      // Convert month number to month name
      const monthName = new Date(Date.UTC(0, month - 1)).toLocaleString('en', { month: 'short' });
      allColumns.push({
        field: `${monthName}${year}`,
        displayName: `${monthName} ${year}`,
        visible: true
      });
    });

    // Sort columns by the month-year field
    allColumns.sort((a, b) => {
      const aDate = new Date(`${a.field.slice(0, 3)} 1, ${a.field.slice(3)}`);
      const bDate = new Date(`${b.field.slice(0, 3)} 1, ${b.field.slice(3)}`);
      return aDate.getTime() - bDate.getTime();
    });

    // Create data array
    const transformedData = data.map(branch => {
      const branchData: any = { branch: branchNameMap[branch.branchid] }; // Use branch name from mapping

      allColumns.forEach(column => {
        if (column.field === 'branch') return;
        const [monthName, year] = column.field.match(/(\D+)(\d{4})/)!.slice(1);
        const month = new Date(Date.parse(`${monthName} 1, ${year}`)).getMonth() + 1;

        const monthData = branch.monthes.find(m => m.month === month && m.year === parseInt(year));
        branchData[column.field] = monthData ? parseFloat(monthData.scorepercent.toFixed(2)) : null; // Format to 2 decimal places
      });

      return branchData;
    });

    console.log(transformedData);
    console.log(allColumns);

    return { allColumns, data: transformedData };
  }

  async getAnalysisAuditTotalScoreYearlyCompare() {
    this.datatableaudittotalscore =[];
    this.allColumns =[];
    this.filter=[];
    this.tableColumns =[];
    try {
      const res = await this.GeneralService.getAnalysisAuditTotalScoreYearly(this.compareForm.value, this.id);
      this.YearsBetweenDates = this.getYearsBetweenDates(this.selectedYearsDates);
      const filteredBranches = res[0].branches.filter(branch => this.compareForm.value.branches.includes(branch.branchid));
      console.log(this.selectedYearsDates);
      const result = this.filterBranchesByMonthAndYearAuditTotalScoreCompareYearly(filteredBranches, this.YearsBetweenDates);

      const { allColumns, data } = this.transformDataAudittotalScoreCompareYear(result, this.Branches);
      this.datatableaudittotalscore = data;
      this.allColumns = allColumns;
      this.filter = this.allColumns.map(col => col.field);

      // Initialize tableColumns based on allColumns visibility
      this.tableColumns = this.allColumns.filter(col => col.visible).map(col => ({
        ...col,
        type: this.getColumnType(col.field)  // Dynamically set type
      }));
      setTimeout(() => {
      }, 2000);
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }

  filterBranchesByMonthAndYearAuditTotalScoreCompareYearly(filteredBranches: any[], dates: any[]) {
    // Create a Set of 'YYYY-MM' strings for the given dates
    const allowedDatesSet = new Set(
      dates.map(date => `${date.year}`)
    );


    // Filter the branches
    return filteredBranches.map(branch => {

      const filteredYears = branch.years.filter(year => {
        const YearString = `${year.year}`;

        const isIncluded = allowedDatesSet.has(YearString);

        return isIncluded;
      });


      return {
        ...branch,
        years: filteredYears
      };
    });
  }

  transformDataAudittotalScoreCompareYear(data: any[], branches: any[]): { allColumns: any[], data: any[] } {
    console.log(data);

    // Create a mapping from branch ID to branch name
    const branchNameMap = branches.reduce((map, branch) => {
      map[branch.id] = branch.name;
      return map;
    }, {} as { [id: string]: string });

    // Create a Set to hold unique year values
    const uniqueYears = new Set<string>();

    // Populate the Set with unique years
    data.forEach(branch => {
      branch.years.forEach(year => {
        const Year = `${year.year}`;
        uniqueYears.add(Year);
      });
    });

    // Create columns array with a fixed first object
    const allColumns = [
      { field: 'branch', displayName: 'Branch', visible: true }
    ];

    // Add columns for each unique year
    uniqueYears.forEach(year => {
      allColumns.push({
        field: `${year}`,
        displayName: `${year}`,
        visible: true
      });
    });

    // Sort columns by the year field
    allColumns.sort((a, b) => {
      const aYear = parseInt(a.field, 10);
      const bYear = parseInt(b.field, 10);
      return aYear - bYear;
    });

    // Create data array
    const transformedData = data.map(branch => {
      const branchData: any = { branch: branchNameMap[branch.branchid] };

      // Create a map to handle multiple scores per year
      const yearScoreMap: { [key: string]: number } = {};

      allColumns.forEach(column => {
        if (column.field === 'branch') return;

        // Extract year from column field
        const year = column.field;

        // Find the data for the current year
        const yearData = branch.years.find(m => m.year === parseInt(year));

        // Handle multiple scores for the same year by keeping a map
        if (yearData) {
          // Example: Concatenate multiple scores into a single string if needed
          yearScoreMap[year] = parseFloat(yearData.scorepercent.toFixed(2));
        } else {
          yearScoreMap[year] = null;
        }
      });

      // Merge the branch data and year score map
      return { ...branchData, ...yearScoreMap };
    });

    console.log(transformedData);
    console.log(allColumns);

    return { allColumns, data: transformedData };
  }

  ////// end 


  //  start
  async getAnalysisAuditDetailedScoreMonthlyCompare() {
    this.MonthsAndYearsBetweenDates =[];
    this.lastfiltereddataDetailedScore = [];
    this.datatableaudittotalscore = [];
    this.allColumns = [];
    this.filter = [];
    this.tableColumns =  [];
    try {


      const res = await this.GeneralService.getAnalysisAuditDetailedScoreMonthly(this.compareForm.value, this.id)
      this.MonthsAndYearsBetweenDates = this.getMonthsAndYearsBetweenDates(this.selectedMonthsDates);
      let x = res[0];
      let filteredresualt = x.cats.filter(item => item.category_name === this.searchForm.get('categories').value);

      filteredresualt = filteredresualt[0].months.filter(item =>
        this.MonthsAndYearsBetweenDates.some(criteria =>
          item.year === criteria.year && item.month === criteria.month));
      this.lastfiltereddataDetailedScore = [];


      filteredresualt = filteredresualt.map(entry => {
        // Filter branches based on the branchIdsToKeep
        const filteredBranches = entry.branches.filter(branch => this.compareForm.get('branches').value.includes(branch.branchid));

        // Return the entry with only the filtered branches
        return {
          ...entry,
          branches: filteredBranches
        };
      }).filter(entry => entry.branches.length > 0); // Remove entries with no branches left


      filteredresualt.sort((a, b) => {
        // First, compare years
        if (a.year !== b.year) {
          return a.year - b.year;
        } else {
          // If years are the same, compare months
          return a.month - b.month;
        }
      });
      console.log(filteredresualt);

      const branchNameMap = this.Branches.reduce((map, branch) => {
        map[branch.id] = branch.name;
        return map;
      }, {});

      const updatedData = filteredresualt.map(record => {
        return {
          ...record,
          branches: record.branches.map(branch => ({
            ...branch,
            branchname: branchNameMap[branch.branchid],  // Replace branchid with branch name
            branchid: undefined  // Optionally remove the branchid property
          }))
        };
      });

      console.log(updatedData);



      const monthYearSet = new Set<string>();

      updatedData.forEach(record => {
        const month = record.month < 10 ? `0${record.month}` : record.month.toString();
        const year = record.year ? record.year.toString() : '';
        if (month && year) {
          monthYearSet.add(`${month}${year}`);
        }
      });

      const columns = [
        { field: "branch", displayName: "Branch", visible: true },
        ...Array.from(monthYearSet).map(my => {
          const month = (my as string).substring(0, 2);
          const year = (my as string).substring(2);  // Use the last two digits of the year

          // Format the year as a 2-digit string
          const yearShort = year.length === 4 ? year.slice(-2) : year;

          const monthName = new Date(2000, Number(month) - 1).toLocaleString('default', { month: 'short' }).toUpperCase();

          return {
            field: `${monthName}${yearShort}`,
            displayName: `${monthName} ${yearShort}`,
            visible: true
          };
        })
      ];

      this.allColumns = columns;



      // Step 2: Calculate the average score percentages for each branch by month-year



      const branchScores = {};

      // Process data
      updatedData.forEach(record => {
        const month = record.month < 10 ? '0' + record.month : record.month.toString();
        const year = record.year.toString(); // Convert year to string
        const monthName = new Date(Number(year), Number(month) - 1).toLocaleString('default', { month: 'short' }).toUpperCase();
        const yearShort = year.slice(-2);  // Extract last 2 digits of the year

        const monthYearKey = `${monthName}${yearShort}`;

        record.branches.forEach(branch => {
          const branchName = branch.branchname;
          const score = branch.scorepercent;

          if (!branchScores[branchName]) {
            branchScores[branchName] = { branch: branchName };
          }

          // Update to use 2-digit year format
          branchScores[branchName][monthYearKey] = score;
        });
      });

      // Example output:
      console.log(branchScores);


      const data = Object.values(branchScores);
      console.log(data, "data table");
      this.datatableaudittotalscore = data;
      this.allColumns = columns;
      this.filter = this.allColumns.map(col => col.field);

      // Initialize tableColumns based on allColumns visibility
      this.tableColumns = this.allColumns.filter(col => col.visible).map(col => ({
        ...col,
        type: this.getColumnType(col.field)  // Dynamically set type

      }));
      console.log(this.tableColumns, "data table")
    } catch (error) {
      console.error('Error fetching or processing data:', error);
    }

  }
  async getAnalysisAuditDetailedScoreYearlyCompare() {

    this.YearsBetweenDates =[];
    this.lastfiltereddataDetailedScore = [];
    this.allColumns =[];
    this.datatableaudittotalscore = [];
    this.allColumns = [];
    this.filter = [];

    // Initialize tableColumns based on allColumns visibility
    this.tableColumns = [];

    try {



      const res = await this.GeneralService.getAnalysisAuditDetailedScoreYearly(this.compareForm.value, this.id);
      this.YearsBetweenDates = this.getYearsBetweenDates(this.selectedYearsDates);

      let x = res[0];
      let filteredresualt = x.cats.filter(item => item.category_name === this.searchForm.get('categories').value);

      filteredresualt = filteredresualt[0].years.filter(item =>
        this.YearsBetweenDates.some(criteria =>
          item.year === criteria.year));
      this.lastfiltereddataDetailedScore = [];


      filteredresualt = filteredresualt.map(entry => {
        // Filter branches based on the branchIdsToKeep
        const filteredBranches = entry.branches.filter(branch => this.compareForm.get('branches').value.includes(branch.branchid));

        // Return the entry with only the filtered branches
        return {
          ...entry,
          branches: filteredBranches
        };
      }).filter(entry => entry.branches.length > 0); // Remove entries with no branches left


      filteredresualt.sort((a, b) => {
        // First, compare years
        if (a.year !== b.year) {
          return a.year - b.year;
        }
      });
      console.log(filteredresualt);


      const branchNameMap = this.Branches.reduce((map, branch) => {
        map[branch.id] = branch.name;
        return map;
      }, {});

      const updatedData = filteredresualt.map(record => {
        return {
          ...record,
          branches: record.branches.map(branch => ({
            ...branch,
            branchname: branchNameMap[branch.branchid],  // Replace branchid with branch name
            branchid: undefined  // Optionally remove the branchid property
          }))
        };
      });

      console.log(updatedData);



      const YearSet = new Set<string>();

      updatedData.forEach(record => {
        const year = record.year ? record.year.toString() : '';
        if (year) {
          YearSet.add(`${year}`);
        }
      });

      const columns = [
        { field: "branch", displayName: "Branch", visible: true },
        ...Array.from(YearSet).map(my => {
          const year = (my as string);  // Use the last two digits of the year

          // Format the year as a 2-digit string


          return {
            field: `${year}`,
            displayName: `${year}`,
            visible: true
          };
        })
      ];

      this.allColumns = columns;



      // Step 2: Calculate the average score percentages for each branch by month-year
      const branchScores = {};
      // Process data
      updatedData.forEach(record => {
        const year = record.year.toString(); // Convert year to string
        const yearShort = year;  // Extract last 2 digits of the year
        const monthYearKey = `${yearShort}`;
        record.branches.forEach(branch => {
          const branchName = branch.branchname;
          const score = branch.scorepercent;

          if (!branchScores[branchName]) {
            branchScores[branchName] = { branch: branchName };
          }
          // Update to use 2-digit year format
          branchScores[branchName][monthYearKey] = score;
        });
      });
      // Example output:
      console.log(branchScores);
      const data = Object.values(branchScores);
      console.log(data, "data table");
      this.datatableaudittotalscore = data;
      this.allColumns = columns;
      this.filter = this.allColumns.map(col => col.field);

      // Initialize tableColumns based on allColumns visibility
      this.tableColumns = this.allColumns.filter(col => col.visible).map(col => ({
        ...col,
        type: this.getColumnType(col.field)  // Dynamically set type

      }));

      console.log(this.tableColumns, "data table")
    } catch (error) {
      console.error('Error fetching or processing data:', error);
    }
  }
  // end




  async getAnalysisDepartmentKpiMonthlyCompare() {
    this.MonthsAndYearsBetweenDates =[];
    this.dataKpis = [];
    this.departmentColumns = [];
    this.filterkpis = [];
    this.kpiColumns = [];

    try {
      this.MonthsAndYearsBetweenDates = this.getMonthsAndYearsBetweenDates(this.selectedMonthsDates);
      const res = await this.GeneralService.getDepartmentKpiMonthlyCompare(this.compareForm.value, this.id, this.MonthsAndYearsBetweenDates)
        .then(data => {
          data = data.filter(array => array.length > 0);


          data = data.flat() // Flatten the nested arrays into a single array
            .sort((a, b) => {
              // First, sort by year
              if (a.year !== b.year) {
                return a.year - b.year;
              }
              // If years are the same, sort by month
              return a.month - b.month;
            });

          data = this.getSortedDataForDepartmentKpi(data);
          console.log(data);





          const uniqueMonthYear = new Set<string>();
          const departmentCounts = {};

          // Collect unique month-year combinations and count departments
          data.forEach(item => {
            const key = `${this.getMonthName(item.month)} ${item.year}`;
            uniqueMonthYear.add(key);

            if (!departmentCounts[key]) {
              departmentCounts[key] = new Set(); // Use a Set to track unique departments
            }

            item.departments.forEach(department => {
              departmentCounts[key].add(department.departmentName); // Add department names to the Set
            });
          });

          // Convert the Set to an array and map it to column definitions
          const monthYearColumns = Array.from(uniqueMonthYear).map(key => {
            const maxDepartmentCount = departmentCounts[key].size; // Get the size of the Set, which is the number of unique departments
            return {
              displayName: key,
              colField: key.replace(/\s+/g, ''),
              colType: 'number',
              maxDepartments: maxDepartmentCount
            };
          });

          // Add the branch column definition at the start
          // const branchColumn = {
          //   displayName: 'Branch',
          //   colField: 'branch',
          //   colType: 'string' 
          // };

          // Combine branch column with month-year columns
          const columns = [...monthYearColumns];
          console.log(data, "before departments");
          //  // Dictionary to store the transformed data by month and year
          //  const result = [];
          //  const seenColfields = new Set();
          // result.push({
          //   colfield: "branch",
          //   display: "Branch",
          //   colType: 'text'
          //  })
          //  data.forEach(entry => {
          //    const month = this.getMonthName(entry.month);
          //    const year = entry.year;

          //    entry.departments.forEach(department => {
          //      const departmentName = department.departmentName;
          //      const colField = `${month}${year}${departmentName}`;

          //      // Only add to result if colField hasn't been seen before
          //      if (!seenColfields.has(colField)) {
          //        seenColfields.add(colField);
          //        result.push({
          //          colfield: colField,
          //          display: departmentName,
          //          colType: 'number'
          //           // Set the column type as 'number' for month-year columns

          //        });
          //      }
          //    });
          //  });

          const result = [];
          const seenColfields = new Set();

          result.push({
            colfield: "branch",
            display: "Branch",
            colType: 'text'
          });

          // Create a temporary structure to organize by month and year
          const tempColumns = {};

          data.forEach(entry => {
            const month = this.getMonthName(entry.month);
            const year = entry.year;
            const monthYearKey = `${month}${year}`;

            // If this month-year key doesn't exist, create it
            if (!tempColumns[monthYearKey]) {
              tempColumns[monthYearKey] = [];
            }

            entry.departments.forEach(department => {
              const departmentName = department.departmentName;
              const colField = `${month}${year}${departmentName}`;

              // Only add to tempColumns if colField hasn't been seen before
              if (!seenColfields.has(colField)) {
                seenColfields.add(colField);
                tempColumns[monthYearKey].push({
                  colfield: colField,
                  display: departmentName,
                  colType: 'number'
                });
              }
            });
          });

          // Now sort the tempColumns object by month and year
          const sortedKeys = Object.keys(tempColumns).sort((a, b) => {
            // Split the month-year keys to compare individually
            const [monthA, yearA] = a.split(' ');
            const [monthB, yearB] = b.split(' ');

            // Convert month names to numbers for numerical sorting (Jan = 1, Feb = 2, etc.)
            const monthNumberA = this.getMonthName(monthA); // Assuming you have a getMonthNumber function
            const monthNumberB = this.getMonthName(monthB);

            // Compare years first
            if (yearA < yearB) {
              return -1;
            } else if (yearA > yearB) {
              return 1;
            } else {
              // If years are the same, compare months
              if (monthNumberA < monthNumberB) {
                return -1;
              } else if (monthNumberA > monthNumberB) {
                return 1;
              } else {
                return 0; // Years and months are the same
              }
            }
          });

          // Finally, populate the result array in the correct order
          result.push(...sortedKeys.flatMap(key => tempColumns[key]));

          data = this.getBranchPercentages(data);
          console.log(data);

          this.dataKpis = data;
          this.departmentColumns = result;
          console.log(this.departmentColumns, " this.departmentColumns");
          this.filterkpis = this.departmentColumns.map(col => col.colfield);


          this.kpiColumns = columns;
          console.log(this.kpiColumns, "this.kpiColumns");


        })
        .catch(error => {
          console.error('Error:', error);
          // Handle error
        });
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }

  }


  async getAnalysisDepartmentKpiYearlyCompare() {
    this.YearsBetweenDates =[];
    this.dataKpis = [];
    this.departmentColumns = [];
    this.filterkpis = [];
    this.kpiColumns = [];
    try {
      this.YearsBetweenDates = this.getYearsBetweenDates(this.selectedYearsDates);
      await this.GeneralService.getDepartmentKpiYearlyCompare(this.compareForm.value, this.id, this.YearsBetweenDates)
        .then(data => {
          data = data.filter(array => array.length > 0);
          data = data.flat() // Flatten the nested arrays into a single array
            .sort((a, b) => {
              // First, sort by year
              if (a.year !== b.year) {
                return a.year - b.year;
              }
              // If years are the same, sort by month
              return a.month - b.month;
            });
          data = this.getSortedDataForDepartmentKpi(data);
          console.log(data);
          const uniqueMonthYear = new Set<string>();
          const departmentCounts = {};
          // Collect unique month-year combinations and count departments
          data.forEach(item => {
            const key = `${item.year}`;
            uniqueMonthYear.add(key);

            if (!departmentCounts[key]) {
              departmentCounts[key] = new Set(); // Use a Set to track unique departments
            }
            item.departments.forEach(department => {
              departmentCounts[key].add(department.departmentName); // Add department names to the Set
            });
          });
          // Convert the Set to an array and map it to column definitions
          const monthYearColumns = Array.from(uniqueMonthYear).map(key => {
            const maxDepartmentCount = departmentCounts[key].size; // Get the size of the Set, which is the number of unique departments
            return {
              displayName: key,
              colField: key.replace(/\s+/g, ''),
              colType: 'number',
              maxDepartments: maxDepartmentCount
            };
          });
          const columns = [...monthYearColumns];
          console.log(data, "before departments");
          const result = [];
          const seenColfields = new Set();
          result.push({
            colfield: "branch",
            display: "Branch",
            colType: 'text'
          });
          // Create a temporary structure to organize by month and year
          const tempColumns = {};
          data.forEach(entry => {
            const year = entry.year;
            const monthYearKey = `${year}`;
            // If this month-year key doesn't exist, create it
            if (!tempColumns[monthYearKey]) {
              tempColumns[monthYearKey] = [];
            }
            entry.departments.forEach(department => {
              const departmentName = department.departmentName;
              const colField = `${year}${departmentName}`;
              // Only add to tempColumns if colField hasn't been seen before
              if (!seenColfields.has(colField)) {
                seenColfields.add(colField);
                tempColumns[monthYearKey].push({
                  colfield: colField,
                  display: departmentName,
                  colType: 'number'
                });
              }
            });
          });
          // Now sort the tempColumns object by month and year
          const sortedKeys = Object.keys(tempColumns).sort((a, b) => {
            // Split the month-year keys to compare individually
            const [yearA] = a.split(' ');
            const [yearB] = b.split(' ');
            // Compare years first
            if (yearA < yearB) {
              return -1;
            } else if (yearA > yearB) {
              return 1;
            } else {
              return 0; // Years and months are the same
            }
          });

          // Finally, populate the result array in the correct order
          result.push(...sortedKeys.flatMap(key => tempColumns[key]));

          data = this.getBranchPercentagesYear(data);
          console.log(data);

          this.dataKpis = data;
          this.departmentColumns = result;
          console.log(this.departmentColumns, " this.departmentColumns");
          this.filterkpis = this.departmentColumns.map(col => col.colfield);


          this.kpiColumns = columns;
          console.log(this.kpiColumns, "this.kpiColumns");


        })
        .catch(error => {
          console.error('Error:', error);
          // Handle error
        });
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }

  }



  // ... other code in your component ...

  getFilterType(colType: string): string {
    switch (colType) {
      case "number": return "numeric"; // Map "number" to "numeric"
      default: return "text"; // Default to text filtering 
    }
  }

  getBranchPercentagesYear(data) {
    const result = [];

    // Track percentages per branch and month
    const branchData = {};

    // Process the data
    data.forEach(item => {
      const branch = item.branchName;
      const moduleId = item.moduleid;
      const year = item.year;

      if (!branchData[branch]) {
        branchData[branch] = {};
      }

      // Iterate through departments and months
      item.departments.forEach((department) => {
        const percent = parseFloat(department.percentfixed2);


        // Construct the key for the month, department, and year 
        const yearKey = `${year}${department.departmentName}`;

        // Add the percentage to the branch data
        if (!branchData[branch][moduleId]) {
          branchData[branch][moduleId] = {};
        }
        branchData[branch][moduleId][yearKey] = percent;
      });
    });

    // Convert the object to the desired array format
    for (const branch in branchData) {
      const branchObj = { branch: branch };
      for (const moduleId in branchData[branch]) {
        for (const key in branchData[branch][moduleId]) {
          branchObj[key] = branchData[branch][moduleId][key];
        }
      }
      result.push(branchObj);
    }

    return result;
  }


  getBranchPercentages(data) {
    const result = [];

    // Track percentages per branch and month
    const branchData = {};

    // Process the data
    data.forEach(item => {
      const branch = item.branchName;
      const moduleId = item.moduleid;
      const year = item.year;

      if (!branchData[branch]) {
        branchData[branch] = {};
      }

      // Iterate through departments and months
      item.departments.forEach((department) => {
        const percent = parseFloat(department.percentfixed2);
        const month = item.month;
        const monthName = this.getMonthName(month); // Get month name

        // Construct the key for the month, department, and year 
        const monthKey = `${monthName}${year}${department.departmentName}`;

        // Add the percentage to the branch data
        if (!branchData[branch][moduleId]) {
          branchData[branch][moduleId] = {};
        }
        branchData[branch][moduleId][monthKey] = percent;
      });
    });

    // Convert the object to the desired array format
    for (const branch in branchData) {
      const branchObj = { branch: branch };
      for (const moduleId in branchData[branch]) {
        for (const key in branchData[branch][moduleId]) {
          branchObj[key] = branchData[branch][moduleId][key];
        }
      }
      result.push(branchObj);
    }

    return result;
  }

  // Helper function to get month name
  getMonthName(month) {
    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    return monthNames[month - 1]; // Adjust for zero-based indexing
  }

  getSortedDataForDepartmentKpi(data: any[]) {
    // Define the branches for lookup


    // Create a lookup dictionary for branches
    const branchLookup = this.Branches.reduce((acc, branch) => {
      acc[branch.id] = branch.name;
      return acc;
    }, {} as { [key: string]: string });

    // Update branchName in data based on branchLookup
    data.forEach(item => {
      const branchName = branchLookup[item.branch];
      item.branchName = branchName || 'Unknown';
    });

    // Sort departments within each data entry
    data.forEach(item => {
      item.departments.sort((a, b) => a.departmentName.localeCompare(b.departmentName));
    });

    // Sort the overall data based on branch, month, and year
    return data.sort((a, b) => {
      if (a.branch !== b.branch) return a.branch.localeCompare(b.branch);
      if (a.month !== b.month) return a.month - b.month;
      return a.year - b.year;
    });
  }
  exportExcelkpi(dp: any) {
    // Get the filtered data
    const filteredData = dp.filteredValue || this.dataKpis;

    // Convert the filtered data to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    // Create a new workbook and append the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Data');

    // Save the workbook as an Excel file
    XLSX.writeFile(wb, 'data.xlsx');
  }

  exportPDFKpi(dp: Table) {
    // Extract the filtered data or use the original data if no filter applied
    const filteredData = dp.filteredValue || this.dataKpis;

    // Create a new jsPDF instance
    const doc = new jspdf.jsPDF();

    // Define column headers and data
    const headers = this.departmentColumns.map(col => col.colfield);
    const data = filteredData.map(customer => this.departmentColumns.map(col => customer[col.colfield]));

    // Generate the PDF
    autoTable(doc, {
      head: [headers],
      body: data,
      startY: 20, // Adjust the start position of the table on the page
      margin: { top: 20 },
      styles: { fontSize: 8 },
      didDrawPage: (data) => {
        // Header
        doc.setFontSize(18);
        doc.text('Data', data.settings.margin.left, 15);
      }
    });

    // Save the PDF
    doc.save('Data.pdf');
  }

  ////// end 





  ////// start
  async getTaskCompilationMonthlyCompare() {
    this.MonthsAndYearsBetweenDates =[];
    this.monthsTaskCompilationcolumns = [];
    this.monthsTaskCompilationopen_closecolumns = [];
    this.taskCompilationCompare = [];
    this.filtertasks = [];

    try {
      this.MonthsAndYearsBetweenDates = this.getMonthsAndYearsBetweenDates(this.selectedMonthsDates);
      await this.GeneralService.getTaskCompilationMonthlyCompare(this.compareForm.value, this.id, this.MonthsAndYearsBetweenDates)
        .then(data => {
          data = data.filter(array => array.length > 0);


          data = data.flat() // Flatten the nested arrays into a single array
            .sort((a, b) => {
              // First, sort by year
              if (a.year !== b.year) {
                return a.year - b.year;
              }
              // If years are the same, sort by month
              return a.month - b.month;
            });
            this.monthsTaskCompilationcolumns = this.generateColumnHeadersMontly(data);
            this.monthsTaskCompilationopen_closecolumns = this.generateColumnHeaders2Monthly(data);
            this.taskCompilationCompare = this.getDataTaskMonthCompareMonthly(data);
            this.filtertasks = this.monthsTaskCompilationopen_closecolumns.map(col => col.colfield);

        })
        .catch(error => {
          console.error('Error:', error);
          // Handle error
        });
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }
  generateColumnHeadersMontly(data: any[]): any[] {
    const uniqueMonths = new Set(data.map((item) => item.month));
    return Array.from(uniqueMonths).map((month) => ({
      displayName: `${this.getMonthName(month)} ${data[0].year}`,
      colField: `${this.getMonthName(month)}${data[0].year}`,
      colType: 'number',
    }));
  }
  generateColumnHeaders2Monthly(data: any[]): any[] {

    const uniqueMonths = new Set(data.map((item) => item.month));

    const columnHeaders: any[] = [
      {
        colfield: 'branch',
        display: 'Branch',
        colType: 'text',
      },
    ];

    Array.from(uniqueMonths).forEach((month) => {
      columnHeaders.push({
        colfield: `${this.getMonthName(month)}${data[0].year}open`,
        display: 'Open',
        colType: 'number',
      });
      columnHeaders.push({
        colfield: `${this.getMonthName(month)}${data[0].year}close`,
        display: 'Close',
        colType: 'number',
      });
    });

    return columnHeaders;
  }
  getDataTaskMonthCompareMonthly(data: any[]): any[] {
  
  console.log(this.Branches);
      const uniqueBranches = new Set(data.map((item) => item.branchid));
      const formattedData: any[] = [];
      Array.from(uniqueBranches).forEach((branchId) => {
        const branchDataEntry = this.Branches.find((item) => item.id === branchId);
        const branchName = branchDataEntry ? branchDataEntry.name : branchId; // Get name or use id if not found
        const branchDataItems = data.filter((item) => item.branchid === branchId);
        const formattedBranch: any = {
          branch: branchName,
        };
        branchDataItems.forEach((item) => {
          const month = this.getMonthName(item.month);
          const year = item.year;  
          formattedBranch[`${month}${year}open`] =
          parseFloat((item.opencount / item.totalcount * 100).toFixed(2));
          formattedBranch[`${month}${year}close`] =
          parseFloat((item.closecount / item.totalcount * 100).toFixed(2));       
        });
        formattedData.push(formattedBranch);
      });
      return formattedData;
  }






  async getTaskCompilationYearlyCompare() {

    this.YearsBetweenDates =[];
    this.monthsTaskCompilationcolumns =[];
    this.monthsTaskCompilationopen_closecolumns = [];
    this.taskCompilationCompare = [];
    this.filtertasks = [];
    try {
      this.YearsBetweenDates = this.getYearsBetweenDates(this.selectedYearsDates);
      await this.GeneralService.getTaskCompilationYearlyCompare(this.compareForm.value, this.id, this.YearsBetweenDates)
        .then(data => {
          data = data.filter(array => array.length > 0);


          data = data.flat() // Flatten the nested arrays into a single array
            .sort((a, b) => {
              // First, sort by year
              if (a.year !== b.year) {
                return a.year - b.year;
              }
            });
            this.monthsTaskCompilationcolumns = this.generateColumnHeadersYearly(data);
            this.monthsTaskCompilationopen_closecolumns = this.generateColumnHeaders2Yearly(data);
            this.taskCompilationCompare = this.getDataTaskMonthCompareYearly(data);
            this.filtertasks = this.monthsTaskCompilationopen_closecolumns.map(col => col.colfield);

          console.log(this.monthsTaskCompilationcolumns)
          console.log(this.monthsTaskCompilationopen_closecolumns)

          console.log(this.taskCompilationCompare)

        })
        .catch(error => {
          console.error('Error:', error);
          // Handle error
        });
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }
  generateColumnHeadersYearly(data: any[]): any[] {
    const uniqueYears = new Set(data.map((item) => item.year));
    return Array.from(uniqueYears).map((year) => ({
      displayName: `${year}`,
      colField: `${year}`,
      colType: 'number',
    }));
  }
  generateColumnHeaders2Yearly(data: any[]): any[] {
    const uniqueYears = new Set(data.map((item) => item.year));
  
    const columnHeaders: any[] = [
      {
        colfield: 'branch',
        display: 'Branch',
        colType: 'text',
      },
    ];
  
    Array.from(uniqueYears).forEach((year) => {
      columnHeaders.push({
        colfield: `${year}open`,
        display: 'Open',
        colType: 'number',
      });
      columnHeaders.push({
        colfield: `${year}close`,
        display: 'Close',
        colType: 'number',
      });
    });
  
    return columnHeaders;
  }
  getDataTaskMonthCompareYearly(data: any[]): any[] {
  
  console.log(this.Branches);
      const uniqueBranches = new Set(data.map((item) => item.branchid));
      const formattedData: any[] = [];
      Array.from(uniqueBranches).forEach((branchId) => {
        const branchDataEntry = this.Branches.find((item) => item.id === branchId);
        const branchName = branchDataEntry ? branchDataEntry.name : branchId; // Get name or use id if not found
        const branchDataItems = data.filter((item) => item.branchid === branchId);
        const formattedBranch: any = {
          branch: branchName,
        };
        branchDataItems.forEach((item) => {
          const year = item.year;  
          formattedBranch[`${year}open`] =
          parseFloat((item.opencount / item.totalcount * 100).toFixed(2));
          formattedBranch[`${year}close`] =
          parseFloat((item.closecount / item.totalcount * 100).toFixed(2));       
        });
        formattedData.push(formattedBranch);
      });
      return formattedData;
  }

  exportExcelTasks(task: any) {
    // Get the filtered data
    const filteredData = task.filteredValue || this.taskCompilationCompare;

    // Convert the filtered data to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    // Create a new workbook and append the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Data');

    // Save the workbook as an Excel file
    XLSX.writeFile(wb, 'data.xlsx');
  }

  exportPDFTasks(task: Table) {
    // Extract the filtered data or use the original data if no filter applied
    const filteredData = task.filteredValue || this.taskCompilationCompare;

    // Create a new jsPDF instance
    const doc = new jspdf.jsPDF();

    // Define column headers and data
    const headers = this.monthsTaskCompilationopen_closecolumns.map(col => col.colfield);
    const data = filteredData.map(customer => this.monthsTaskCompilationopen_closecolumns.map(col => customer[col.colfield]));
    // Generate the PDF
    autoTable(doc, {
      head: [headers],
      body: data,
      startY: 20, // Adjust the start position of the table on the page
      margin: { top: 20 },
      styles: { fontSize: 8 },
      didDrawPage: (data) => {
        // Header
        doc.setFontSize(18);
        doc.text('Data', data.settings.margin.left, 15);
      }
    });

    // Save the PDF
    doc.save('Data.pdf');
  }


  //////// end




  async getStandardCompilationMonthlyCompare() {
    this.MonthsAndYearsBetweenDates =[];
    this.monthsStandardCompilationcolumns =[];
    this.monthsStandardCompilationopen_closecolumns = [];
    this.StandardCompilationCompare = [];
    this.filterStandard = [];


    try {
      this.MonthsAndYearsBetweenDates = this.getMonthsAndYearsBetweenDates(this.selectedMonthsDates);
      await this.GeneralService.getStandardCompilationMonthlyCompare(this.compareForm.value, this.id, this.MonthsAndYearsBetweenDates)
        .then(data => {
          data = data.filter(array => array.length > 0);


          data = data.flat() // Flatten the nested arrays into a single array
            .sort((a, b) => {
              // First, sort by year
              if (a.year !== b.year) {
                return a.year - b.year;
              }
              // If years are the same, sort by month
              return a.month - b.month;
            });
            this.monthsStandardCompilationcolumns = this.generateStandardColumnHeadersMontly(data);
            console.log(this.monthsStandardCompilationcolumns,"monthsStandardCompilationcolumns");
            this.monthsStandardCompilationopen_closecolumns = this.generateStandardColumnHeaders2Monthly(data);
            this.StandardCompilationCompare = this.getDataStandardMonthCompareMonthly(data);
            this.filterStandard = this.monthsStandardCompilationopen_closecolumns.map(col => col.colfield);

            console.log( this.monthsStandardCompilationcolumns)
            console.log( this.monthsStandardCompilationopen_closecolumns)
            console.log( this.StandardCompilationCompare)


        })
        .catch(error => {
          console.error('Error:', error);
          // Handle error
        });
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }


  generateStandardColumnHeadersMontly(data: any[]): any[] {
    console.log(data, "generateStandardColumnHeadersMontly");
    const uniqueMonths = new Set(data.map((item) => item.month));
    
    return Array.from(uniqueMonths).map((month) => {
      // Find the year of the current month by checking the corresponding data item
      const year = data.find((item) => item.month === month)?.year;
      
      return {
        displayName: `${this.getMonthName(month)} ${year}`, // Use the year dynamically here
        colField: `${this.getMonthName(month)}${year}`,
        colType: 'number',
      };
    });
  }
  

  // generateStandardColumnHeadersMontly(data: any[]): any[] {
  //   console.log(data,"generateStandardColumnHeadersMontly");
  //   const uniqueMonths = new Set(data.map((item) => item.month));
  //   return Array.from(uniqueMonths).map((month) => ({
  //     displayName: `${this.getMonthName(month)} ${data[0].year}`,
  //     colField: `${this.getMonthName(month)}${data[0].year}`,
  //     colType: 'number',
  //   }));
  // }
  // generateStandardColumnHeaders2Monthly(data: any[]): any[] {

  //   const uniqueMonths = new Set(data.map((item) => item.month));

  //   const columnHeaders: any[] = [
  //     {
  //       colfield: 'branch',
  //       display: 'Branch',
  //       colType: 'text',
  //     },
  //   ];

  //   Array.from(uniqueMonths).forEach((month) => {
  //     columnHeaders.push({
  //       colfield: `${this.getMonthName(month)}${data[0].year}C`,
  //       display: 'C',
  //       colType: 'number',
  //     });
  //     columnHeaders.push({
  //       colfield: `${this.getMonthName(month)}${data[0].year}NC`,
  //       display: 'NC',
  //       colType: 'number',
  //     });
  //     columnHeaders.push({
  //       colfield: `${this.getMonthName(month)}${data[0].year}M`,
  //       display: 'M',
  //       colType: 'number',
  //     });
  //   });

  //   return columnHeaders;
  // }
  generateStandardColumnHeaders2Monthly(data: any[]): any[] {

    const uniqueMonths = new Set(data.map((item) => item.month));
  
    const columnHeaders: any[] = [
      {
        colfield: 'branch',
        display: 'Branch',
        colType: 'text',
      },
    ];
  
    // Loop through each unique month
    Array.from(uniqueMonths).forEach((month) => {
      // Dynamically fetch the year corresponding to the month
      const year = data.find((item) => item.month === month)?.year;
  
      if (year) {
        // Construct the column headers for each month-year combination (C, NC, M)
        columnHeaders.push({
          colfield: `${this.getMonthName(month)}${year}C`,  // Example: 'January2024C'
          display: 'C',
          colType: 'number',
        });
        columnHeaders.push({
          colfield: `${this.getMonthName(month)}${year}NC`, // Example: 'January2024NC'
          display: 'NC',
          colType: 'number',
        });
        columnHeaders.push({
          colfield: `${this.getMonthName(month)}${year}M`,  // Example: 'January2024M'
          display: 'M',
          colType: 'number',
        });
      }
    });
  
    return columnHeaders;
  }
  
  getDataStandardMonthCompareMonthly(data: any[]): any[] {
  
  console.log(this.Branches);
      const uniqueBranches = new Set(data.map((item) => item.branchid));
      const formattedData: any[] = [];
      Array.from(uniqueBranches).forEach((branchId) => {
        const branchDataEntry = this.Branches.find((item) => item.id === branchId);
        const branchName = branchDataEntry ? branchDataEntry.name : branchId; // Get name or use id if not found
        const branchDataItems = data.filter((item) => item.branchid === branchId);
        const formattedBranch: any = {
          branch: branchName,
        };
        branchDataItems.forEach((item) => {
          const month = this.getMonthName(item.month);
          const year = item.year;  
          formattedBranch[`${month}${year}C`] =
          parseFloat((item.countC / item.totalcount * 100).toFixed(2));
          formattedBranch[`${month}${year}NC`] =
          parseFloat((item.countNc / item.totalcount * 100).toFixed(2));     
          formattedBranch[`${month}${year}M`] =
          parseFloat((item.countM / item.totalcount * 100).toFixed(2));  
        });
        formattedData.push(formattedBranch);
      });
      return formattedData;
  }




  async getStandardCompilationYearlyCompare() {
    this.YearsBetweenDates =[];
    this.monthsStandardCompilationcolumns = [];
    this.monthsStandardCompilationopen_closecolumns = [];
    this.StandardCompilationCompare = [];
    this.filterStandard = [];

    try {
      this.YearsBetweenDates = this.getYearsBetweenDates(this.selectedYearsDates);
      await this.GeneralService.getStandardCompilationYearlyCompare(this.compareForm.value, this.id, this.YearsBetweenDates)
        .then(data => {
          data = data.filter(array => array.length > 0);


          data = data.flat() // Flatten the nested arrays into a single array
            .sort((a, b) => {
              // First, sort by year
              if (a.year !== b.year) {
                return a.year - b.year;
              }
            });
            this.monthsStandardCompilationcolumns = this.generateStandardColumnHeadersYearly(data);
            this.monthsStandardCompilationopen_closecolumns = this.generateStandardColumnHeaders2Yearly(data);
            this.StandardCompilationCompare = this.getDataStandardMonthCompareYearly(data);
            this.filterStandard = this.monthsStandardCompilationopen_closecolumns.map(col => col.colfield);

          console.log(this.monthsTaskCompilationcolumns)
          console.log(this.monthsTaskCompilationopen_closecolumns)

          console.log(this.taskCompilationCompare)

        })
        .catch(error => {
          console.error('Error:', error);
          // Handle error
        });
    } catch (error) {
      console.error('Error fetching or processing data:', error);
      // Handle error as needed
    }
  }
  generateStandardColumnHeadersYearly(data: any[]): any[] {
    const uniqueYears = new Set(data.map((item) => item.year));
    return Array.from(uniqueYears).map((year) => ({
      displayName: `${year}`,
      colField: `${year}`,
      colType: 'number',
    }));
  }
  generateStandardColumnHeaders2Yearly(data: any[]): any[] {
    const uniqueYears = new Set(data.map((item) => item.year));
  
    const columnHeaders: any[] = [
      {
        colfield: 'branch',
        display: 'Branch',
        colType: 'text',
      },
    ];
  
    Array.from(uniqueYears).forEach((year) => {
      columnHeaders.push({
        colfield: `${year}C`,
        display: 'C',
        colType: 'number',
      });
      columnHeaders.push({
        colfield: `${year}NC`,
        display: 'NC',
        colType: 'number',
      });
      columnHeaders.push({
        colfield: `${year}M`,
        display: 'M',
        colType: 'number',
      });
    });
  
    return columnHeaders;
  }
  getDataStandardMonthCompareYearly(data: any[]): any[] {
  
  console.log(this.Branches);
      const uniqueBranches = new Set(data.map((item) => item.branchid));
      const formattedData: any[] = [];
      Array.from(uniqueBranches).forEach((branchId) => {
        const branchDataEntry = this.Branches.find((item) => item.id === branchId);
        const branchName = branchDataEntry ? branchDataEntry.name : branchId; // Get name or use id if not found
        const branchDataItems = data.filter((item) => item.branchid === branchId);
        const formattedBranch: any = {
          branch: branchName,
        };
        branchDataItems.forEach((item) => {
          const year = item.year;  
          formattedBranch[`${year}C`] =
          parseFloat((item.countC / item.totalcount * 100).toFixed(2));
          formattedBranch[`${year}NC`] =
          parseFloat((item.countNc / item.totalcount * 100).toFixed(2));     
          formattedBranch[`${year}M`] =
          parseFloat((item.countM / item.totalcount * 100).toFixed(2));      
        });
        formattedData.push(formattedBranch);
      });
      return formattedData;
  }


















  exportExcelStandards(standard: any) {
    // Get the filtered data
    const filteredData = standard.filteredValue || this.StandardCompilationCompare;

    // Convert the filtered data to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    // Create a new workbook and append the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Data');

    // Save the workbook as an Excel file
    XLSX.writeFile(wb, 'data.xlsx');
  }

  exportPDFStandards(standard: Table) {
    // Extract the filtered data or use the original data if no filter applied
    const filteredData = standard.filteredValue || this.StandardCompilationCompare;

    // Create a new jsPDF instance
    const doc = new jspdf.jsPDF();

    // Define column headers and data
    const headers = this.monthsStandardCompilationopen_closecolumns.map(col => col.colfield);
    const data = filteredData.map(customer => this.monthsStandardCompilationopen_closecolumns.map(col => customer[col.colfield]));

    // Generate the PDF
    autoTable(doc, {
      head: [headers],
      body: data,
      startY: 20, // Adjust the start position of the table on the page
      margin: { top: 20 },
      styles: { fontSize: 8 },
      didDrawPage: (data) => {
        // Header
        doc.setFontSize(18);
        doc.text('Data', data.settings.margin.left, 15);
      }
    });

    // Save the PDF
    doc.save('Data.pdf');
  }  
}

























